export const global_marketlist = {
  "1": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1x2",
    "group": "all|score|regular_play"
  },
  "2": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Se qualifie",
    "group": "all|score|cup_tie"
  },
  "3": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Quelle équipe gagnera la finale ?",
    "group": "all|score|cup_tie"
  },
  "4": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Quelle équipe gagnera la finale pour la 3e place ?",
    "group": "all|score|cup_tie"
  },
  "5": {
    "14": "{$competitor1} temps réglementaire",
    "15": "{$competitor2} temps réglementaire",
    "16": "{$competitor1} prolongations",
    "17": "{$competitor2} prolongations",
    "18": "{$competitor1} séance de tirs au but",
    "19": "{$competitor2} séance de tirs au but",
    "name": "Méthode de victoire",
    "group": "all|score|cup_tie"
  },
  "6": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Quelle équipe va donner le coup denvoi ?",
    "group": "all|misc"
  },
  "7": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Quelle équipe va gagner le reste du match ?",
    "group": "all|score|regular_play"
  },
  "8": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!goalnr} but",
    "group": "all|score|regular_play"
  },
  "9": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Dernier but",
    "group": "all|score|regular_play"
  },
  "10": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "Double chance",
    "group": "all|score|regular_play"
  },
  "11": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Remboursé si match nul",
    "group": "all|score|regular_play"
  },
  "12": {
    "776": "Match nul",
    "778": "{$competitor2}",
    "name": "{$competitor1} remboursé si victoire",
    "group": "all|score|regular_play"
  },
  "13": {
    "780": "{$competitor1}",
    "782": "Match nul",
    "name": "{$competitor2} remboursé si victoire",
    "group": "all|score|regular_play"
  },
  "14": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "16": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap",
    "group": "all|score|regular_play"
  },
  "18": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total",
    "group": "all|score|regular_play"
  },
  "19": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total",
    "group": "all|score|regular_play"
  },
  "20": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total",
    "group": "all|score|regular_play"
  },
  "26": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair",
    "group": "all|score|regular_play"
  },
  "27": {
    "70": "impair",
    "72": "pair",
    "name": "{$competitor1} Pair/Impair",
    "group": "all|score|regular_play"
  },
  "28": {
    "70": "impair",
    "72": "pair",
    "name": "{$competitor2} Pair/Impair",
    "group": "all|score|regular_play"
  },
  "29": {
    "74": "oui",
    "76": "non",
    "name": "Les deux équipes qui marquent",
    "group": "all|score|regular_play"
  },
  "30": {
    "784": "aucune",
    "788": "seulement {$competitor1}",
    "790": "seulement {$competitor2}",
    "792": "les deux équipes",
    "name": "Quelle équipe va marquer",
    "group": "all|score|regular_play"
  },
  "31": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} cage inviolée",
    "group": "all|score|regular_play"
  },
  "32": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} cage inviolée",
    "group": "all|score|regular_play"
  },
  "33": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagne sans prendre de buts",
    "group": "all|score|regular_play"
  },
  "34": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagne sans prendre de buts",
    "group": "all|score|regular_play"
  },
  "35": {
    "78": "{$competitor1} & oui",
    "80": "{$competitor1} & non",
    "82": "Match nul & oui",
    "84": "Match nul & non",
    "86": "{$competitor2} & oui",
    "88": "{$competitor2} & non",
    "name": "1x2 & Les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "36": {
    "90": "{total} + & oui",
    "92": "{total} - & oui",
    "94": "{total} + & non",
    "96": "{total} - & non",
    "name": "Total & Les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "37": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "X & {total} -",
    "800": "X & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & total",
    "group": "all|regular_play|combo|incl_ot"
  },
  "41": {
    "110": "0:0",
    "114": "1:0",
    "116": "2:0",
    "118": "3:0",
    "120": "4:0",
    "122": "5:0",
    "124": "6:0",
    "126": "0:1",
    "128": "1:1",
    "130": "2:1",
    "132": "3:1",
    "134": "4:1",
    "136": "5:1",
    "138": "0:2",
    "140": "1:2",
    "142": "2:2",
    "144": "3:2",
    "146": "4:2",
    "148": "0:3",
    "150": "1:3",
    "152": "2:3",
    "154": "3:3",
    "156": "0:4",
    "158": "1:4",
    "160": "2:4",
    "162": "0:5",
    "164": "1:5",
    "166": "0:6",
    "name": "Score correct {!score}",
    "group": "all|score|regular_play"
  },
  "45": {
    "274": "0:0",
    "276": "1:0",
    "278": "2:0",
    "280": "3:0",
    "282": "4:0",
    "284": "0:1",
    "286": "1:1",
    "288": "2:1",
    "290": "3:1",
    "292": "4:1",
    "294": "0:2",
    "296": "1:2",
    "298": "2:2",
    "300": "3:2",
    "302": "4:2",
    "304": "0:3",
    "306": "1:3",
    "308": "2:3",
    "310": "3:3",
    "312": "4:3",
    "314": "0:4",
    "316": "1:4",
    "318": "2:4",
    "320": "3:4",
    "322": "4:4",
    "324": "autre",
    "name": "Score correct",
    "group": "all|score|regular_play"
  },
  "46": {
    "326": "0:0 0:0",
    "328": "0:0 0:1",
    "330": "0:0 0:2",
    "332": "0:0 0:3",
    "334": "0:0 1:0",
    "336": "0:0 1:1",
    "338": "0:0 1:2",
    "340": "0:0 2:0",
    "342": "0:0 2:1",
    "344": "0:0 3:0",
    "346": "0:0 4+",
    "348": "0:1 0:1",
    "350": "0:1 0:2",
    "352": "0:1 0:3",
    "354": "0:1 1:1",
    "356": "0:1 1:2",
    "358": "0:1 2:1",
    "360": "0:1 4+",
    "362": "0:2 0:2",
    "364": "0:2 0:3",
    "366": "0:2 1:2",
    "368": "0:2 4+",
    "370": "0:3 0:3",
    "372": "0:3 4+",
    "374": "1:0 1:0",
    "376": "1:0 1:1",
    "378": "1:0 1:2",
    "380": "1:0 2:0",
    "382": "1:0 2:1",
    "384": "1:0 3:0",
    "386": "1:0 4+",
    "388": "1:1 1:1",
    "390": "1:1 1:2",
    "392": "1:1 2:1",
    "394": "1:1 4+",
    "396": "1:2 1:2",
    "398": "1:2 4+",
    "400": "2:0 2:0",
    "402": "2:0 2:1",
    "404": "2:0 3:0",
    "406": "2:0 4+",
    "408": "2:1 2:1",
    "410": "2:1 4+",
    "412": "3:0 3:0",
    "414": "3:0 4+",
    "416": "4+ 4+",
    "name": "Mi-temps/Fin de match score correct",
    "group": "all|score|regular_play"
  },
  "47": {
    "418": "{$competitor1}/{$competitor1}",
    "420": "{$competitor1}/Match nul",
    "422": "{$competitor1}/{$competitor2}",
    "424": "Match nul/{$competitor1}",
    "426": "Match nul/Match nul",
    "428": "Match nul/{$competitor2}",
    "430": "{$competitor2}/{$competitor1}",
    "432": "{$competitor2}/Match nul",
    "434": "{$competitor2}/{$competitor2}",
    "name": "Mi-temps/Fin de match",
    "group": "all|score|regular_play"
  },
  "48": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagne les deux périodes",
    "group": "all|score|regular_play"
  },
  "49": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagne les deux périodes",
    "group": "all|score|regular_play"
  },
  "50": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagne une des périodes",
    "group": "all|score|regular_play"
  },
  "51": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagne une des périodes",
    "group": "all|score|regular_play"
  },
  "52": {
    "436": "1ère mi-temps",
    "438": "2ème mi-temps",
    "440": "égal",
    "name": "Mi-temps avec le plus de buts marqués",
    "group": "all|score|regular_play"
  },
  "53": {
    "436": "1ère mi-temps",
    "438": "2ème mi-temps",
    "440": "égal",
    "name": "{$competitor1} Mi-temps avec le plus de buts marqués",
    "group": "all|score|regular_play"
  },
  "54": {
    "436": "1ère mi-temps",
    "438": "2ème mi-temps",
    "440": "égal",
    "name": "{$competitor2} Mi-temps avec le plus de buts marqués",
    "group": "all|score|regular_play"
  },
  "55": {
    "806": "non/non",
    "808": "oui/non",
    "810": "oui/oui",
    "812": "non/oui",
    "name": "1ere/2ème mi-temps Les deux équipes qui marquent",
    "group": "all|score|regular_play"
  },
  "56": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} qui marque dans les deux périodes",
    "group": "all|score|regular_play"
  },
  "57": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} qui marque dans les deux périodes",
    "group": "all|score|regular_play"
  },
  "58": {
    "74": "oui",
    "76": "non",
    "name": "Les deux mi-temps {total} +",
    "group": "all|score|regular_play"
  },
  "59": {
    "74": "oui",
    "76": "non",
    "name": "Les deux mi-temps {total} -",
    "group": "all|score|regular_play"
  },
  "60": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1ère mi-temps - 1x2",
    "group": "all|score|1st_half"
  },
  "61": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1ère mi-temps - quelle équipe gagne le reste",
    "group": "all|score|1st_half"
  },
  "62": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - {!goalnr} but",
    "group": "all|score|1st_half"
  },
  "63": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "1ère mi-temps - double chance",
    "group": "all|score|1st_half"
  },
  "64": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1ère mi-temps - remboursé si match nul",
    "group": "all|score|1st_half"
  },
  "65": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1ère mi-temps - handicap {hcp}",
    "group": "all|score|1st_half"
  },
  "66": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1ère mi-temps - handicap",
    "group": "all|score|1st_half"
  },
  "68": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - total",
    "group": "all|score|1st_half"
  },
  "69": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor1} total",
    "group": "all|score|1st_half"
  },
  "70": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor2} total",
    "group": "all|score|1st_half"
  },
  "74": {
    "70": "impair",
    "72": "pair",
    "name": "1ère mi-temps - pair/impair",
    "group": "all|score|1st_half"
  },
  "75": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - les deux équipes qui marquent",
    "group": "all|score|1st_half"
  },
  "76": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - {$competitor1} cage inviolée",
    "group": "all|score|1st_half"
  },
  "77": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - {$competitor2} cage inviolée",
    "group": "all|score|1st_half"
  },
  "78": {
    "78": "{$competitor1} & oui",
    "80": "{$competitor1} & non",
    "82": "Match nul & oui",
    "84": "Match nul & non",
    "86": "{$competitor2} & oui",
    "88": "{$competitor2} & non",
    "name": "1ère mi-temps - 1x2 & les deux équipes qui marquent",
    "group": "all|combo|1st_half"
  },
  "79": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1ère mi-temps - 1x2 & total",
    "group": "all|combo|1st_half"
  },
  "80": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "1ère mi-temps - score correct {!score}",
    "group": "all|score|1st_half"
  },
  "81": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "autre",
    "name": "1ère mi-temps - score correct",
    "group": "all|score|1st_half"
  },
  "83": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "2ème mi-temps - 1x2",
    "group": "all|score|2nd_half"
  },
  "84": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "2ème mi-temps - {!goalnr} but",
    "group": "all|score|2nd_half"
  },
  "85": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "2ème mi-temps - double chance",
    "group": "all|score|2nd_half"
  },
  "86": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2ème mi-temps - remboursé si match nul",
    "group": "all|score|2nd_half"
  },
  "87": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "2ème mi-temps - handicap {hcp}",
    "group": "all|score|2nd_half"
  },
  "88": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2ème mi-temps - handicap",
    "group": "all|score|2nd_half"
  },
  "90": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2ème mi-temps - total",
    "group": "all|score|2nd_half"
  },
  "91": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2ème mi-temps - {$competitor1} total",
    "group": "all|score|2nd_half"
  },
  "92": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2ème mi-temps - {$competitor2} total",
    "group": "all|score|2nd_half"
  },
  "94": {
    "70": "impair",
    "72": "pair",
    "name": "2ème mi-temps - pair/impair",
    "group": "all|score|2nd_half"
  },
  "95": {
    "74": "oui",
    "76": "non",
    "name": "2ème mi-temps - les deux équipes qui marquent",
    "group": "all|score|2nd_half"
  },
  "96": {
    "74": "oui",
    "76": "non",
    "name": "2ème mi-temps - {$competitor1} cage inviolée",
    "group": "all|score|2nd_half"
  },
  "97": {
    "74": "oui",
    "76": "non",
    "name": "2ème mi-temps - {$competitor2} cage inviolée",
    "group": "all|score|2nd_half"
  },
  "98": {
    "546": "0:0",
    "548": "0:1",
    "550": "0:2",
    "552": "1:0",
    "554": "1:1",
    "556": "1:2",
    "558": "2:0",
    "560": "2:1",
    "562": "2:2",
    "564": "autre",
    "name": "2ème mi-temps - score correct",
    "group": "all|score|2nd_half"
  },
  "100": {
    "584": "1-15",
    "586": "16-30",
    "588": "31-45",
    "590": "46-60",
    "592": "61-75",
    "594": "76-90",
    "596": "aucun",
    "name": "Quand le {!goalnr} but sera-t-il marqué (intervalle 15 minutes)",
    "group": "all|score|regular_play"
  },
  "101": {
    "598": "1-10",
    "600": "11-20",
    "602": "21-30",
    "604": "31-40",
    "606": "41-50",
    "608": "51-60",
    "610": "61-70",
    "612": "71-80",
    "614": "81-90",
    "616": "aucun",
    "name": "Quand le {!goalnr} but sera-t-il marqué (intervalle 10 minutes)",
    "group": "all|score|regular_play"
  },
  "102": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "15 minutes - 1x2 de {from} à {to}",
    "group": "all|score|15_min"
  },
  "103": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "15 minutes - {!goalnr} but de {from} à {to}",
    "group": "all|score|15_min"
  },
  "104": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 minutes - total de {from} à {to}",
    "group": "all|score|15_min"
  },
  "105": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "10 minutes - 1x2 de {from} à {to}",
    "group": "all|score|10_min"
  },
  "106": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "10 minutes - {!goalnr} but de {from} à {to}",
    "group": "all|score|10_min"
  },
  "107": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 minutes - total de {from} à {to}",
    "group": "all|score|10_min"
  },
  "108": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "5 minutes - 1x2 de {from} à {to}",
    "group": "all|score|5_min"
  },
  "109": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "5 minutes - {!goalnr} but de {from} à {to}",
    "group": "all|score|5_min"
  },
  "110": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 minutes - total de {from} à {to}",
    "group": "all|score|5_min"
  },
  "112": {
    "74": "oui",
    "76": "non",
    "name": "Prolongations & but",
    "group": "all|combo|ot"
  },
  "113": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Prolongations - 1x2",
    "group": "all|score|ot"
  },
  "114": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Prolongations - quelle équipe gagne le reste",
    "group": "all|score|ot"
  },
  "115": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Prolongations - {!goalnr} but",
    "group": "all|score|ot"
  },
  "116": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Prolongations - total",
    "group": "all|score|ot"
  },
  "117": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Prolongations - handicap",
    "group": "all|score|ot"
  },
  "118": {
    "442": "0:0",
    "444": "1:0",
    "446": "2:0",
    "448": "3:0",
    "450": "0:1",
    "452": "1:1",
    "454": "2:1",
    "456": "0:2",
    "458": "1:2",
    "460": "0:3",
    "name": "Prolongations - score correct {!score}",
    "group": "all|score|ot"
  },
  "119": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Prolongations 1ère mi-temps - 1x2",
    "group": "all|score|ot_1st_half"
  },
  "120": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Prolongations 1ère mi-temps - handicap",
    "group": "all|score|ot_1st_half"
  },
  "121": {
    "618": "0:0",
    "620": "1:0",
    "622": "2:0",
    "624": "0:1",
    "626": "1:1",
    "628": "0:2",
    "name": "Prolongations 1ère mi-temps - score correct {!score}",
    "group": "all|score|ot_1st_half"
  },
  "122": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il une séance de tirs au but ?",
    "group": "all|score|incl_ot"
  },
  "123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Séance de tirs au but - vainqueur",
    "group": "all|score|pen_so"
  },
  "124": {
    "74": "oui",
    "76": "non",
    "name": "Séance de tirs au but - {!penaltynr} penalty marqué",
    "group": "all|score|pen_so"
  },
  "125": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Séance de tirs au but - {!goalnr} but",
    "group": "all|score|pen_so"
  },
  "126": {
    "630": "{$competitor1} par 1",
    "632": "{$competitor1} par 2",
    "634": "{$competitor1} par 3 ou +",
    "636": "{$competitor2} par 1",
    "638": "{$competitor2} par 2",
    "640": "{$competitor2} par 3 ou +",
    "name": "Séance de tirs au but - marge de victoire",
    "group": "all|score|pen_so"
  },
  "127": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Séance de tirs au but - total",
    "group": "all|score|pen_so"
  },
  "128": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Séance de tirs au but - {$competitor1} total",
    "group": "all|score|pen_so"
  },
  "129": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Séance de tirs au but - {$competitor2} total",
    "group": "all|score|pen_so"
  },
  "131": {
    "70": "impair",
    "72": "pair",
    "name": "Séance de tirs au but - pair/impair",
    "group": "all|score|pen_so"
  },
  "132": {
    "70": "impair",
    "72": "pair",
    "name": "Séance de tirs au but - {$competitor1} pair/impair",
    "group": "all|score|pen_so"
  },
  "133": {
    "70": "impair",
    "72": "pair",
    "name": "Séance de tirs au but - {$competitor2} pair/impair",
    "group": "all|score|pen_so"
  },
  "134": {
    "656": "{$competitor1} & {total} -",
    "658": "{$competitor2} & {total} -",
    "660": "{$competitor1} & {total} +",
    "662": "{$competitor2} & {total} +",
    "name": "Séance de tirs au but - vainqueur & total",
    "group": "all|combo|pen_so"
  },
  "135": {
    "1767": "0:1",
    "1768": "0:2",
    "1769": "0:3",
    "1770": "1:0",
    "1771": "1:2",
    "1772": "1:3",
    "1773": "1:4",
    "1774": "2:0",
    "1775": "2:1",
    "1776": "2:3",
    "1777": "2:4",
    "1778": "3:0",
    "1779": "3:1",
    "1780": "3:2",
    "1781": "3:4",
    "1782": "3:5",
    "1783": "4:1",
    "1784": "4:2",
    "1785": "4:3",
    "1786": "4:5",
    "1787": "5:3",
    "1788": "5:4",
    "1789": "autre",
    "name": "Séance de tirs au but - score correct",
    "group": "all|score|pen_so"
  },
  "136": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Cartons 1x2",
    "group": "all|regular_play|bookings"
  },
  "137": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!bookingnr} carton",
    "group": "all|regular_play|bookings"
  },
  "138": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total points cartons",
    "group": "all|regular_play|bookings"
  },
  "139": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total cartons",
    "group": "all|regular_play|bookings"
  },
  "140": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total cartons",
    "group": "all|regular_play|bookings"
  },
  "141": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total cartons",
    "group": "all|regular_play|bookings"
  },
  "142": {
    "710": "0-3",
    "712": "4",
    "714": "5",
    "716": "6",
    "718": "7",
    "720": "8",
    "722": "9",
    "724": "10",
    "726": "11",
    "728": "12+",
    "name": "Nombre exact de cartons",
    "group": "all|regular_play|bookings"
  },
  "143": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor1} nombre exact de cartons",
    "group": "all|regular_play|bookings"
  },
  "144": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "{$competitor2} nombre exact de cartons",
    "group": "all|regular_play|bookings"
  },
  "146": {
    "74": "oui",
    "76": "non",
    "name": "Expulsion",
    "group": "all|regular_play|bookings"
  },
  "147": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} expulsion",
    "group": "all|regular_play|bookings"
  },
  "148": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} expulsion",
    "group": "all|regular_play|bookings"
  },
  "149": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1ère mi-temps - Cartons 1x2",
    "group": "all|1st_half|bookings"
  },
  "150": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - {!bookingnr} carton",
    "group": "all|1st_half|bookings"
  },
  "151": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - Total points cartons",
    "group": "all|1st_half|bookings"
  },
  "152": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - Total cartons",
    "group": "all|1st_half|bookings"
  },
  "153": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor1} total cartons",
    "group": "all|1st_half|bookings"
  },
  "154": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor2} total cartons",
    "group": "all|1st_half|bookings"
  },
  "155": {
    "1760": "0",
    "1761": "1",
    "1762": "2",
    "1763": "3",
    "1764": "4",
    "1765": "5",
    "1766": "6+",
    "name": "1ère mi-temps - Nombre exact de cartons",
    "group": "all|1st_half|bookings"
  },
  "156": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1ère mi-temps - {$competitor1} nombre exact de cartons",
    "group": "all|1st_half|bookings"
  },
  "157": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "1ère mi-temps - {$competitor2} nombre exact de cartons",
    "group": "all|1st_half|bookings"
  },
  "159": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - Expulsion ?",
    "group": "all|1st_half|bookings"
  },
  "160": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - {$competitor1} expulsion",
    "group": "all|1st_half|bookings"
  },
  "161": {
    "74": "oui",
    "76": "non",
    "name": "1ère mi-temps - {$competitor2} expulsion",
    "group": "all|1st_half|bookings"
  },
  "162": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Corners 1x2",
    "group": "all|regular_play|corners"
  },
  "163": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!cornernr} corner",
    "group": "all|regular_play|corners"
  },
  "164": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Dernier corner",
    "group": "all|regular_play|corners"
  },
  "165": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Corners handicap",
    "group": "all|regular_play|corners"
  },
  "166": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total corners",
    "group": "all|regular_play|corners"
  },
  "167": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total corners",
    "group": "all|regular_play|corners"
  },
  "168": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total corners",
    "group": "all|regular_play|corners"
  },
  "172": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair corners",
    "group": "all|regular_play|corners"
  },
  "173": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1ère mi-temps - corners 1x2",
    "group": "all|1st_half|corners"
  },
  "174": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - {!cornernr} corner",
    "group": "all|1st_half|corners"
  },
  "175": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - dernier corner",
    "group": "all|1st_half|corners"
  },
  "176": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1ère mi-temps - corners handicap",
    "group": "all|1st_half|corners"
  },
  "177": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - total corners",
    "group": "all|1st_half|corners"
  },
  "178": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor1} total corners",
    "group": "all|1st_half|corners"
  },
  "179": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor2} total corners",
    "group": "all|1st_half|corners"
  },
  "180": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1ère mi-temps - {$competitor1} nombre exact de corners",
    "group": "all|1st_half|corners"
  },
  "181": {
    "730": "0-1",
    "732": "2",
    "734": "3",
    "736": "4+",
    "name": "1ère mi-temps - {$competitor2} nombre exact de corners",
    "group": "all|1st_half|corners"
  },
  "183": {
    "70": "impair",
    "72": "pair",
    "name": "1ère mi-temps - pair/Impair corners",
    "group": "all|1st_half|corners"
  },
  "184": {
    "814": "but {$competitor1} & {$competitor1}",
    "816": "but {$competitor1} & Match nul",
    "818": "but {$competitor1} & {$competitor2}",
    "820": "but {$competitor2} & {$competitor1}",
    "822": "but {$competitor2} & Match nul",
    "824": "but {$competitor2} & {$competitor2}",
    "826": "aucun but",
    "name": "{!goalnr} but & 1x2",
    "group": "all|regular_play|combo"
  },
  "186": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Vainqueur",
    "group": "all|score|regular_play"
  },
  "187": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Jeux handicap",
    "group": "all|score|regular_play"
  },
  "188": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Set handicap",
    "group": "all|score|regular_play"
  },
  "189": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total jeux",
    "group": "all|score|regular_play"
  },
  "190": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total jeux",
    "group": "all|score|regular_play"
  },
  "191": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total jeux",
    "group": "all|score|regular_play"
  },
  "192": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} remporte un set",
    "group": "all|score|regular_play"
  },
  "193": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} remporte un set",
    "group": "all|score|regular_play"
  },
  "194": {
    "74": "oui",
    "76": "non",
    "name": "Un des sets sans concéder de jeu",
    "group": "all|score|regular_play"
  },
  "195": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un Tie-break ?",
    "group": "all|score|regular_play"
  },
  "198": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/impair jeux",
    "group": "all|score|regular_play"
  },
  "201": {
    "861": "{$competitor1}/{$competitor1}",
    "862": "{$competitor2}/{$competitor1}",
    "863": "{$competitor1}/{$competitor2}",
    "864": "{$competitor2}/{$competitor2}",
    "name": "Résulat double (1er set/match)",
    "group": "all|score|regular_play"
  },
  "202": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - vainqueur",
    "group": "all|score|set"
  },
  "203": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - jeux handicap",
    "group": "all|score|set"
  },
  "204": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - total jeux",
    "group": "all|score|set"
  },
  "205": {
    "70": "impair",
    "72": "pair",
    "name": "{!setnr} set - pair/impair jeux",
    "group": "all|score|set"
  },
  "206": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set - y aura-t-il un Tie-break ?",
    "group": "all|score|set"
  },
  "207": {
    "865": "6:0",
    "866": "6:1",
    "867": "6:2",
    "868": "6:3",
    "869": "6:4",
    "870": "7:5",
    "871": "7:6",
    "872": "0:6",
    "873": "1:6",
    "874": "2:6",
    "875": "3:6",
    "876": "4:6",
    "877": "5:7",
    "878": "6:7",
    "name": "{!setnr} set - score correct",
    "group": "all|score|set"
  },
  "208": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - atteindra en premier {games} jeux",
    "group": "all|score|set"
  },
  "209": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!setnr} set - vainqueur {!gamenrX} et {!gamenrY} jeu",
    "group": "all|score|game"
  },
  "210": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set jeu {gamenr} - vainqueur",
    "group": "all|score|game"
  },
  "211": {
    "882": "4",
    "883": "5",
    "884": "6",
    "885": "7+",
    "name": "{!setnr} set jeu {gamenr} - nombre exact de points",
    "group": "all|score|game"
  },
  "212": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set jeu {gamenr} - va à égalité",
    "group": "all|score|game"
  },
  "213": {
    "70": "impair",
    "72": "pair",
    "name": "{!setnr} set jeu {gamenr} - pair/impair points",
    "group": "all|score|game"
  },
  "214": {
    "886": "{$competitor1} à 0",
    "887": "{$competitor1} à 15",
    "888": "{$competitor1} à 30",
    "889": "{$competitor1} à 40",
    "890": "{$competitor2} à 0",
    "891": "{$competitor2} à 15",
    "892": "{$competitor2} à 30",
    "893": "{$competitor2} à 40",
    "name": "{!setnr} set jeu {gamenr} - score correct",
    "group": "all|score|game"
  },
  "215": {
    "894": "{%server} à 0",
    "895": "{%server} à 15",
    "896": "{%server} à 30",
    "897": "{%server} à 40",
    "898": "break",
    "name": "{!setnr} set jeu {gamenr} - score correct ou break",
    "group": "all|score|game"
  },
  "216": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set jeu {gamenr} - atteindra en premier {pointnr} points",
    "group": "all|score|points"
  },
  "217": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!setnr} set jeu {gamenr} - vainqueur {pointnr} premiers points",
    "group": "all|score|points"
  },
  "218": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set jeu {gamenr} - {!pointnr} point",
    "group": "all|score|points"
  },
  "219": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Vainqueur (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "220": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il des prolongations ?",
    "group": "all|score|regular_play"
  },
  "221": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!scorenr} score (inclus prolongations)",
    "group": "all"
  },
  "222": {
    "901": "touchdown",
    "902": "coup de pied",
    "903": "autre",
    "904": "aucun",
    "name": "{!scorenr} manière de marquer (prolongation incl.)",
    "group": "all"
  },
  "223": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "224": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap US (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "225": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "226": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total US (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "227": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "228": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "229": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "230": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Atteindra en premier {pointnr} points (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "231": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "2ème mi-temps - handicap (inclus prolongations)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "232": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "2ème mi-temps - total (inclus prolongations)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "234": {
    "920": "1er quart-temps",
    "921": "2ème quart-temps",
    "922": "3ème quart-temps",
    "923": "4ème quart-temps",
    "924": "égal",
    "name": "Quart-temps le plus prolifique au score",
    "group": "all|score|regular_play"
  },
  "235": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!quarternr} quart-temps - 1x2",
    "group": "all|score|quarter"
  },
  "236": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} quart-temps - total",
    "group": "all|score|quarter"
  },
  "237": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap points",
    "group": "all|score|regular_play"
  },
  "238": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total points",
    "group": "all|score|regular_play"
  },
  "245": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} jeu - vainqueur",
    "group": "all|score|game"
  },
  "246": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!gamenr} jeu - handicap points",
    "group": "all|score|game"
  },
  "247": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!gamenr} jeu - total points",
    "group": "all|score|game"
  },
  "248": {
    "70": "impair",
    "72": "pair",
    "name": "{!gamenr} jeu - pair/impair",
    "group": "all|score|game"
  },
  "250": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} jeu - atteindra en premier {pointnr} points",
    "group": "all|score|game"
  },
  "251": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Vainqueur (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "252": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1x2 (inclus manches supplémentaires)",
    "group": "all"
  },
  "253": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Quelle équipe va gagner le reste du match (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "254": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "255": {
    "630": "{$competitor1} par 1",
    "632": "{$competitor1} par 2",
    "634": "{$competitor1} par 3 ou +",
    "636": "{$competitor2} par 1",
    "638": "{$competitor2} par 2",
    "640": "{$competitor2} par 3 ou +",
    "name": "Marge de victoire (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "256": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "257": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap US (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "258": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "259": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total US (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "260": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "261": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "262": {
    "939": "{total} -",
    "940": "exact {total}",
    "941": "{total} +",
    "name": "Total (plus de-exact-moins de (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "264": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "265": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & total (inclus manches supplémentaires)",
    "group": "all|combo|incl_ei"
  },
  "266": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!runnr} run (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "267": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Atteindra en premier {runnr} runs (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "268": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il une manche supplémentaire ?",
    "group": "all|score|regular_play"
  },
  "269": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} va attaquer dans la 9ème manche",
    "group": "all|score|regular_play"
  },
  "270": {
    "948": "{$competitor1}",
    "949": "Match nul",
    "950": "{$competitor2}",
    "name": "Equipe qui gagne le plus de manches",
    "group": "all|score|regular_play"
  },
  "271": {
    "948": "{$competitor1}",
    "949": "Match nul",
    "950": "{$competitor2}",
    "name": "Equipe qui marque le plus de points dans une manche",
    "group": "all|score|regular_play"
  },
  "272": {
    "951": "1ère manche",
    "952": "2ème manche",
    "953": "3ème manche",
    "954": "4ème manche",
    "955": "5ème manche",
    "956": "6ème manche",
    "957": "7ème manche",
    "958": "8ème manche",
    "959": "9ème manche",
    "960": "égal",
    "name": "Manche avec le plus de points marqués",
    "group": "all|score|regular_play"
  },
  "273": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Nombre exact de runs dans la manche la plus prolifique au score",
    "group": "all|score|regular_play"
  },
  "274": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Manches 1 à 5 - 1x2",
    "group": "all|score|5_innings"
  },
  "275": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Manches 1 à 5 - handicap",
    "group": "all|score|5_innings"
  },
  "276": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - total",
    "group": "all|score|5_innings"
  },
  "277": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - {$competitor1} total",
    "group": "all|score|5_innings"
  },
  "278": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - {$competitor2} total",
    "group": "all|score|5_innings"
  },
  "279": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Manches 1 à haut de la 5ème - 1x2",
    "group": "all|score|4.5_innings"
  },
  "280": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Manches 1 à haut de la 5ème - handicap",
    "group": "all|score|4.5_innings"
  },
  "281": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à haut de la 5ème - total",
    "group": "all|score|4.5_innings"
  },
  "282": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à haut de la 5ème - {$competitor1} total",
    "group": "all|score|4.5_innings"
  },
  "283": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à haut de la 5ème - {$competitor2} total",
    "group": "all|score|4.5_innings"
  },
  "284": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches {from} à {to} - total",
    "group": "all|score|3_innings"
  },
  "285": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches {from} à {to} - {$competitor1} total",
    "group": "all|score|3_innings"
  },
  "286": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches {from} à {to} - {$competitor2} total",
    "group": "all|score|3_innings"
  },
  "287": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche - 1x2",
    "group": "all|score|inning"
  },
  "288": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - total",
    "group": "all|score|inning"
  },
  "289": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Quelle équipe gagne lengagement ?",
    "group": "all|misc"
  },
  "291": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!pointnr} point (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "292": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Vainqueur & total (inclus prolongations)",
    "group": "all|combo|incl_ot"
  },
  "293": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "2ème mi-temps - 1x2 (inclus prolongations)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "294": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2ème mi-temps - remboursé si match nul (inclus prolongations)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "295": {
    "70": "impair",
    "72": "pair",
    "name": "2ème mi-temps - pair/impair (inclus prolongations)",
    "group": "all|score|combo|incl_ot|2nd_half_incl_ot"
  },
  "297": {
    "939": "{total} -",
    "940": "exact {total}",
    "941": "{total} +",
    "name": "Total (plus de -exact- moins de)",
    "group": "all|score|regular_play"
  },
  "300": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Atteindra en premier {pointnr} points",
    "group": "all|score|regular_play"
  },
  "301": {
    "1002": "{$competitor1} par 3 ou +",
    "1003": "{$competitor2} par 3 ou +",
    "1004": "autre",
    "name": "{!quarternr} quart-temps - marge de victoire",
    "group": "all|score|quarter"
  },
  "302": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quart-temps - remboursé si match nul",
    "group": "all|score|quarter"
  },
  "303": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} quart-temps - handicap",
    "group": "all|score|quarter"
  },
  "304": {
    "70": "impair",
    "72": "pair",
    "name": "{!quarternr} quart-temps - pair/impair",
    "group": "all|score|quarter"
  },
  "305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quart-temps - atteindra en premier {pointnr} points",
    "group": "all|score|quarter"
  },
  "309": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - point handicap",
    "group": "all|score|set"
  },
  "310": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - total points",
    "group": "all|score|set"
  },
  "311": {
    "70": "impair",
    "72": "pair",
    "name": "{!setnr} set - pair/impair",
    "group": "all|score|set"
  },
  "312": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - {!pointnr} point",
    "group": "all|score|set"
  },
  "313": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - atteindra en premier {pointnr} points",
    "group": "all|score|set"
  },
  "314": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total sets",
    "group": "all|score|regular_play"
  },
  "315": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!setnr} set - 1x2",
    "group": "all|score|set"
  },
  "316": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set - remboursé si match nul",
    "group": "all|score|set"
  },
  "317": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!setnr} set - handicap {hcp}",
    "group": "all|score|set"
  },
  "318": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total",
    "group": "all|score|set"
  },
  "319": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total",
    "group": "all|score|set"
  },
  "322": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set manche {endnr} - vainqueur",
    "group": "all|score|end"
  },
  "323": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set manche {endnr} - total",
    "group": "all|score|end"
  },
  "324": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "{!setnr} set manche {endnr} - nombre exact de points",
    "group": "all|score|end"
  },
  "325": {
    "70": "impair",
    "72": "pair",
    "name": "{!setnr} set manche {endnr} - pair/impair",
    "group": "all|score|end"
  },
  "326": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Map handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "327": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Map handicap",
    "group": "all|score|regular_play"
  },
  "328": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total maps",
    "group": "all|score|regular_play"
  },
  "330": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - vainqueur (inclus prolongations)",
    "group": "all|score|map_incl_ot"
  },
  "331": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - manche handicap (inclus prolongations)",
    "group": "all|score|map_incl_ot"
  },
  "332": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map - total manches (inclus prolongations)",
    "group": "all|score|map_incl_ot"
  },
  "333": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} kill",
    "group": "all|kills|map"
  },
  "334": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!mapnr} map - 1x2",
    "group": "all|score|map"
  },
  "335": {
    "74": "oui",
    "76": "non",
    "name": "{!mapnr} map - Y aura-t-il des prolongations ?",
    "group": "all|score|map"
  },
  "337": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map manche au couteau - vainqueur",
    "group": "all|round"
  },
  "338": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map manche {roundnr} - vainqueur",
    "group": "all|round"
  },
  "340": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Vainqueur (inclus le Super Over)",
    "group": "all|score|incl_so"
  },
  "341": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un Super Over ?",
    "group": "all|score|regular_play"
  },
  "342": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il une égalité ?",
    "group": "all|score|regular_play"
  },
  "343": {
    "1031": "arrêt de volée",
    "1032": "Guichet détruit par le lanceur",
    "1033": "Jambe devant guichet",
    "1034": "run out",
    "1035": "Guichet détruit par le gardien",
    "1036": "autres",
    "name": "{!inningnr} manche - {!dismissalnr} méthode délimination",
    "group": "all|dismissal|innings"
  },
  "344": {
    "1037": "arrêt de volée",
    "1038": "pas d arrêt de volée",
    "name": "{!inningnr} manche - {!dismissalnr} méthode délimination (limité)",
    "group": "all|dismissal|innings"
  },
  "347": {
    "948": "{$competitor1}",
    "949": "Match nul",
    "950": "{$competitor2}",
    "name": "{!inningnr} manche - équipe avec la série de lancers la plus prolifique au score",
    "group": "all|score|innings"
  },
  "349": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total à la {!dismissalnr} élimination",
    "group": "all|score|innings"
  },
  "350": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total à la {!dismissalnr} élimination",
    "group": "all|score|innings"
  },
  "351": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche Séries de lancers 0 à {overnr} - 1x2",
    "group": "all|score|x_overs"
  },
  "352": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Séries de lancers 0 à {overnr} - {$competitor1} total",
    "group": "all|score|x_overs"
  },
  "353": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Séries de lancers 0 à {overnr} - {$competitor2} total",
    "group": "all|score|x_overs"
  },
  "356": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor1} total",
    "group": "all|score|over"
  },
  "357": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor2} total",
    "group": "all|score|over"
  },
  "358": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère série de lancers - total",
    "group": "all|score|over"
  },
  "359": {
    "70": "impair",
    "72": "pair",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor1} pair/impair",
    "group": "all|score|over"
  },
  "360": {
    "70": "impair",
    "72": "pair",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor2} pair/impair",
    "group": "all|score|over"
  },
  "361": {
    "70": "impair",
    "72": "pair",
    "name": "1ère série de lancers - pair/impair",
    "group": "all|score|over"
  },
  "362": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers {overnr} - {!deliverynr} lancer {$competitor1} total",
    "group": "all|score|delivery"
  },
  "363": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers {overnr} - {!deliverynr} lancer {$competitor2} total",
    "group": "all|score|delivery"
  },
  "365": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Set handicap {hcp}",
    "group": "all|score|regular_play"
  },
  "366": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Manche handicap",
    "group": "all|score|regular_play"
  },
  "367": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total manches",
    "group": "all|score|regular_play"
  },
  "368": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair sets",
    "group": "all|score|regular_play"
  },
  "370": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!setnr} set - quel joueur va gagner le reste",
    "group": "all|score|set"
  },
  "371": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - manche handicap",
    "group": "all|score|set"
  },
  "372": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - total manches",
    "group": "all|score|set"
  },
  "373": {
    "70": "impair",
    "72": "pair",
    "name": "{!setnr} set - pair/impair manches",
    "group": "all|score|set"
  },
  "375": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!setnr} set manche {legnr} - vainqueur",
    "group": "all|score|leg"
  },
  "376": {
    "1039": "{total} +",
    "1040": "{total} -",
    "name": "{!setnr} set manche {legnr} - total fléchettes",
    "group": "all|score|leg"
  },
  "377": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "Match nul",
    "name": "{!setnr} set manche {legnr} - joueur qui marque le plus de points sur la {!visitnr} volée",
    "group": "all|score|visit"
  },
  "378": {
    "1044": "0-89",
    "1045": "90-100",
    "1046": "101+",
    "name": "{!setnr} set manche {legnr} - Nombre de points sur la {!visitnr} volée (fourchette)",
    "group": "all|score|visit"
  },
  "379": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set manche {legnr} - score du finish {score}+",
    "group": "all|leg|checkout"
  },
  "380": {
    "1049": "rouge",
    "1050": "vert",
    "name": "{!setnr} set manche {legnr} - dernière couleur du finish",
    "group": "all|leg|checkout"
  },
  "381": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "Match nul",
    "name": "Le plus de 180",
    "group": "all|regular_play|180s"
  },
  "382": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!xth} joueur qui marque un 180",
    "group": "all|regular_play|180s"
  },
  "383": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "180 handicap",
    "group": "all|regular_play|180s"
  },
  "384": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total de 180",
    "group": "all|regular_play|180s"
  },
  "385": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total de 180",
    "group": "all|regular_play|180s"
  },
  "386": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total de 180",
    "group": "all|regular_play|180s"
  },
  "387": {
    "1041": "{$competitor1}",
    "1042": "{$competitor2}",
    "1043": "Match nul",
    "name": "{!setnr} set - le plus de 180",
    "group": "all|set|180s"
  },
  "388": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - total de 180",
    "group": "all|set|180s"
  },
  "389": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total de 180",
    "group": "all|set|180s"
  },
  "390": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total de 180",
    "group": "all|set|180s"
  },
  "391": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set manche {legnr} - un des joueurs va faire un 180",
    "group": "all|leg|180s"
  },
  "392": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set manche {legnr} - {$competitor1} va faire un 180",
    "group": "all|leg|180s"
  },
  "393": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set manche {legnr} - {$competitor2} va faire un 180",
    "group": "all|leg|180s"
  },
  "395": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - vainqueur",
    "group": "all|map"
  },
  "396": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} égide",
    "group": "all|map|structures"
  },
  "397": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} tour",
    "group": "all|map|structures"
  },
  "398": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} caserne",
    "group": "all|map|structures"
  },
  "401": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "Score correct {!score}",
    "group": "all|score|regular_play"
  },
  "402": {
    "1058": "0:0",
    "1059": "0:1",
    "1060": "0:2",
    "1061": "0:3",
    "1062": "0:4",
    "1063": "0:5",
    "1064": "0:6",
    "1065": "0:7",
    "1066": "0:8",
    "1067": "0:9",
    "1068": "0:10",
    "1069": "0:11",
    "1070": "0:12",
    "1071": "0:13",
    "1072": "0:14",
    "1073": "0:15",
    "1074": "0:16",
    "1075": "0:17",
    "1076": "0:18",
    "1077": "0:19",
    "1078": "1:0",
    "1079": "1:1",
    "1080": "1:2",
    "1081": "1:3",
    "1082": "1:4",
    "1083": "1:5",
    "1084": "1:6",
    "1085": "1:7",
    "1086": "1:8",
    "1087": "1:9",
    "1088": "1:10",
    "1089": "1:11",
    "1090": "1:12",
    "1091": "1:13",
    "1092": "1:14",
    "1093": "1:15",
    "1094": "1:16",
    "1095": "1:17",
    "1096": "1:18",
    "1097": "1:19",
    "1098": "2:0",
    "1099": "2:1",
    "1100": "2:2",
    "1101": "2:3",
    "1102": "2:4",
    "1103": "2:5",
    "1104": "2:6",
    "1105": "2:7",
    "1106": "2:8",
    "1107": "2:9",
    "1108": "2:10",
    "1109": "2:11",
    "1110": "2:12",
    "1111": "2:13",
    "1112": "2:14",
    "1113": "2:15",
    "1114": "2:16",
    "1115": "2:17",
    "1116": "2:18",
    "1117": "2:19",
    "1118": "3:0",
    "1119": "3:1",
    "1120": "3:2",
    "1121": "3:3",
    "1122": "3:4",
    "1123": "3:5",
    "1124": "3:6",
    "1125": "3:7",
    "1126": "3:8",
    "1127": "3:9",
    "1128": "3:10",
    "1129": "3:11",
    "1130": "3:12",
    "1131": "3:13",
    "1132": "3:14",
    "1133": "3:15",
    "1134": "3:16",
    "1135": "3:17",
    "1136": "3:18",
    "1137": "3:19",
    "1138": "4:0",
    "1139": "4:1",
    "1140": "4:2",
    "1141": "4:3",
    "1142": "4:4",
    "1143": "4:5",
    "1144": "4:6",
    "1145": "4:7",
    "1146": "4:8",
    "1147": "4:9",
    "1148": "4:10",
    "1149": "4:11",
    "1150": "4:12",
    "1151": "4:13",
    "1152": "4:14",
    "1153": "4:15",
    "1154": "4:16",
    "1155": "4:17",
    "1156": "4:18",
    "1157": "4:19",
    "1158": "5:0",
    "1159": "5:1",
    "1160": "5:2",
    "1161": "5:3",
    "1162": "5:4",
    "1163": "5:5",
    "1164": "5:6",
    "1165": "5:7",
    "1166": "5:8",
    "1167": "5:9",
    "1168": "5:10",
    "1169": "5:11",
    "1170": "5:12",
    "1171": "5:13",
    "1172": "5:14",
    "1173": "5:15",
    "1174": "5:16",
    "1175": "5:17",
    "1176": "5:18",
    "1177": "5:19",
    "1178": "6:0",
    "1179": "6:1",
    "1180": "6:2",
    "1181": "6:3",
    "1182": "6:4",
    "1183": "6:5",
    "1184": "6:6",
    "1185": "6:7",
    "1186": "6:8",
    "1187": "6:9",
    "1188": "6:10",
    "1189": "6:11",
    "1190": "6:12",
    "1191": "6:13",
    "1192": "6:14",
    "1193": "6:15",
    "1194": "6:16",
    "1195": "6:17",
    "1196": "6:18",
    "1197": "6:19",
    "1198": "7:0",
    "1199": "7:1",
    "1200": "7:2",
    "1201": "7:3",
    "1202": "7:4",
    "1203": "7:5",
    "1204": "7:6",
    "1205": "7:7",
    "1206": "7:8",
    "1207": "7:9",
    "1208": "7:10",
    "1209": "7:11",
    "1210": "7:12",
    "1211": "7:13",
    "1212": "7:14",
    "1213": "7:15",
    "1214": "7:16",
    "1215": "7:17",
    "1216": "7:18",
    "1217": "7:19",
    "1218": "8:0",
    "1219": "8:1",
    "1220": "8:2",
    "1221": "8:3",
    "1222": "8:4",
    "1223": "8:5",
    "1224": "8:6",
    "1225": "8:7",
    "1226": "8:8",
    "1227": "8:9",
    "1228": "8:10",
    "1229": "8:11",
    "1230": "8:12",
    "1231": "8:13",
    "1232": "8:14",
    "1233": "8:15",
    "1234": "8:16",
    "1235": "8:17",
    "1236": "8:18",
    "1237": "8:19",
    "1238": "9:0",
    "1239": "9:1",
    "1240": "9:2",
    "1241": "9:3",
    "1242": "9:4",
    "1243": "9:5",
    "1244": "9:6",
    "1245": "9:7",
    "1246": "9:8",
    "1247": "9:9",
    "1248": "9:10",
    "1249": "9:11",
    "1250": "9:12",
    "1251": "9:13",
    "1252": "9:14",
    "1253": "9:15",
    "1254": "9:16",
    "1255": "9:17",
    "1256": "9:18",
    "1257": "9:19",
    "1258": "10:0",
    "1259": "10:1",
    "1260": "10:2",
    "1261": "10:3",
    "1262": "10:4",
    "1263": "10:5",
    "1264": "10:6",
    "1265": "10:7",
    "1266": "10:8",
    "1267": "10:9",
    "1268": "10:10",
    "1269": "10:11",
    "1270": "10:12",
    "1271": "10:13",
    "1272": "10:14",
    "1273": "10:15",
    "1274": "10:16",
    "1275": "10:17",
    "1276": "10:18",
    "1277": "10:19",
    "1278": "11:0",
    "1279": "11:1",
    "1280": "11:2",
    "1281": "11:3",
    "1282": "11:4",
    "1283": "11:5",
    "1284": "11:6",
    "1285": "11:7",
    "1286": "11:8",
    "1287": "11:9",
    "1288": "11:10",
    "1289": "11:11",
    "1290": "11:12",
    "1291": "11:13",
    "1292": "11:14",
    "1293": "11:15",
    "1294": "11:16",
    "1295": "11:17",
    "1296": "11:18",
    "1297": "11:19",
    "1298": "12:0",
    "1299": "12:1",
    "1300": "12:2",
    "1301": "12:3",
    "1302": "12:4",
    "1303": "12:5",
    "1304": "12:6",
    "1305": "12:7",
    "1306": "12:8",
    "1307": "12:9",
    "1308": "12:10",
    "1309": "12:11",
    "1310": "12:12",
    "1311": "12:13",
    "1312": "12:14",
    "1313": "12:15",
    "1314": "12:16",
    "1315": "12:17",
    "1316": "12:18",
    "1317": "12:19",
    "1318": "13:0",
    "1319": "13:1",
    "1320": "13:2",
    "1321": "13:3",
    "1322": "13:4",
    "1323": "13:5",
    "1324": "13:6",
    "1325": "13:7",
    "1326": "13:8",
    "1327": "13:9",
    "1328": "13:10",
    "1329": "13:11",
    "1330": "13:12",
    "1331": "13:13",
    "1332": "13:14",
    "1333": "13:15",
    "1334": "13:16",
    "1335": "13:17",
    "1336": "13:18",
    "1337": "13:19",
    "1338": "14:0",
    "1339": "14:1",
    "1340": "14:2",
    "1341": "14:3",
    "1342": "14:4",
    "1343": "14:5",
    "1344": "14:6",
    "1345": "14:7",
    "1346": "14:8",
    "1347": "14:9",
    "1348": "14:10",
    "1349": "14:11",
    "1350": "14:12",
    "1351": "14:13",
    "1352": "14:14",
    "1353": "14:15",
    "1354": "14:16",
    "1355": "14:17",
    "1356": "14:18",
    "1357": "14:19",
    "1358": "15:0",
    "1359": "15:1",
    "1360": "15:2",
    "1361": "15:3",
    "1362": "15:4",
    "1363": "15:5",
    "1364": "15:6",
    "1365": "15:7",
    "1366": "15:8",
    "1367": "15:9",
    "1368": "15:10",
    "1369": "15:11",
    "1370": "15:12",
    "1371": "15:13",
    "1372": "15:14",
    "1373": "15:15",
    "1374": "15:16",
    "1375": "15:17",
    "1376": "15:18",
    "1377": "15:19",
    "1378": "16:0",
    "1379": "16:1",
    "1380": "16:2",
    "1381": "16:3",
    "1382": "16:4",
    "1383": "16:5",
    "1384": "16:6",
    "1385": "16:7",
    "1386": "16:8",
    "1387": "16:9",
    "1388": "16:10",
    "1389": "16:11",
    "1390": "16:12",
    "1391": "16:13",
    "1392": "16:14",
    "1393": "16:15",
    "1394": "16:16",
    "1395": "16:17",
    "1396": "16:18",
    "1397": "16:19",
    "1398": "17:0",
    "1399": "17:1",
    "1400": "17:2",
    "1401": "17:3",
    "1402": "17:4",
    "1403": "17:5",
    "1404": "17:6",
    "1405": "17:7",
    "1406": "17:8",
    "1407": "17:9",
    "1408": "17:10",
    "1409": "17:11",
    "1410": "17:12",
    "1411": "17:13",
    "1412": "17:14",
    "1413": "17:15",
    "1414": "17:16",
    "1415": "17:17",
    "1416": "17:18",
    "1417": "17:19",
    "1418": "18:0",
    "1419": "18:1",
    "1420": "18:2",
    "1421": "18:3",
    "1422": "18:4",
    "1423": "18:5",
    "1424": "18:6",
    "1425": "18:7",
    "1426": "18:8",
    "1427": "18:9",
    "1428": "18:10",
    "1429": "18:11",
    "1430": "18:12",
    "1431": "18:13",
    "1432": "18:14",
    "1433": "18:15",
    "1434": "18:16",
    "1435": "18:17",
    "1436": "18:18",
    "1437": "18:19",
    "1438": "19:0",
    "1439": "19:1",
    "1440": "19:2",
    "1441": "19:3",
    "1442": "19:4",
    "1443": "19:5",
    "1444": "19:6",
    "1445": "19:7",
    "1446": "19:8",
    "1447": "19:9",
    "1448": "19:10",
    "1449": "19:11",
    "1450": "19:12",
    "1451": "19:13",
    "1452": "19:14",
    "1453": "19:15",
    "1454": "19:16",
    "1455": "19:17",
    "1456": "19:18",
    "1457": "19:19",
    "name": "1ère mi -temps - score correct {!score}",
    "group": "all|score|1st_half"
  },
  "404": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!goalnr} but (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "405": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Atteindra en premier {goalnr} buts (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "406": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Vainqueur (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "407": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!goalnr} but (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "408": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Handicap {hcp} (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "409": {
    "630": "{$competitor1} par 1",
    "632": "{$competitor1} par 2",
    "634": "{$competitor1} par 3 ou +",
    "636": "{$competitor2} par 1",
    "638": "{$competitor2} par 2",
    "640": "{$competitor2} par 3 ou +",
    "name": "Marge de victoire (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "410": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "411": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Handicap US (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "412": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "413": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total US (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "414": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "415": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "419": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "420": {
    "1475": "les deux",
    "1476": "seulement {$competitor1}",
    "1477": "seulement {$competitor2}",
    "name": "Quelle équipe va marquer (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "421": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} cage inviolée (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "422": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} cage inviolée (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "423": {
    "1478": "but {$competitor1} & {$competitor1}",
    "1479": "but {$competitor1} & {$competitor2}",
    "1480": "but {$competitor2} & {$competitor1}",
    "1481": "but {$competitor2} & {$competitor2}",
    "name": "{!goalnr} but & vainqueur (inclus prolongations et séance de tirs au but)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "424": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1x2 & total (inclus prolongations et séance de tirs au but)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "425": {
    "1706": "{$competitor1} & oui",
    "1708": "{$competitor1} & non",
    "1709": "{$competitor2} & oui",
    "1710": "{$competitor2} & non",
    "name": "1x2 & les deux équipes qui marquent (inclus prolongations et séance de tirs au but)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "426": {
    "1482": "{$competitor1} & {$competitor1}",
    "1483": "Match nul & {$competitor1}",
    "1484": "{$competitor2} & {$competitor1}",
    "1485": "{$competitor1} & {$competitor2}",
    "1486": "Match nul & {$competitor2}",
    "1487": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} période 1x2 & vainqueur (inclus prolongations et séance de tirs au but)",
    "group": "all|combo|incl_ot_and_pen"
  },
  "427": {
    "1488": "1:0",
    "1489": "2:0",
    "1490": "3:0",
    "1491": "4:0",
    "1492": "5:0",
    "1493": "0:1",
    "1494": "2:1",
    "1495": "3:1",
    "1496": "4:1",
    "1497": "5:1",
    "1498": "0:2",
    "1499": "1:2",
    "1500": "3:2",
    "1501": "4:2",
    "1502": "5:2",
    "1503": "0:3",
    "1504": "1:3",
    "1505": "2:3",
    "1506": "4:3",
    "1507": "5:3",
    "1508": "0:4",
    "1509": "1:4",
    "1510": "2:4",
    "1511": "3:4",
    "1512": "5:4",
    "1513": "0:5",
    "1514": "1:5",
    "1515": "2:5",
    "1516": "3:5",
    "1517": "4:5",
    "1518": "autre",
    "name": "Score correct (inclus prolongations et séance de tirs au but)",
    "group": "all|score|incl_ot_and_pen"
  },
  "429": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "Match nul & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & Match nul",
    "1533": "Match nul & Match nul",
    "1534": "{$competitor2} & Match nul",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "Match nul & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{!periodnr} période 1x2 & 1x2",
    "group": "all|regular_play|combo"
  },
  "430": {
    "1538": "0:0",
    "1539": "1:0",
    "1540": "2:0",
    "1541": "3:0",
    "1542": "4:0",
    "1543": "5:0",
    "1544": "6:0",
    "1545": "7:0",
    "1546": "8:0",
    "1547": "0:1",
    "1548": "1:1",
    "1549": "2:1",
    "1550": "3:1",
    "1551": "4:1",
    "1552": "5:1",
    "1553": "6:1",
    "1554": "7:1",
    "1555": "0:2",
    "1556": "1:2",
    "1557": "2:2",
    "1558": "3:2",
    "1559": "4:2",
    "1560": "5:2",
    "1561": "6:2",
    "1562": "0:3",
    "1563": "1:3",
    "1564": "2:3",
    "1565": "3:3",
    "1566": "4:3",
    "1567": "5:3",
    "1568": "0:4",
    "1569": "1:4",
    "1570": "2:4",
    "1571": "3:4",
    "1572": "4:4",
    "1573": "0:5",
    "1574": "1:5",
    "1575": "2:5",
    "1576": "3:5",
    "1577": "0:6",
    "1578": "1:6",
    "1579": "2:6",
    "1580": "0:7",
    "1581": "1:7",
    "1582": "0:8",
    "name": "Score correct {!score}",
    "group": "all|score|regular_play"
  },
  "431": {
    "1584": "0:0",
    "1585": "1:0",
    "1586": "2:0",
    "1587": "3:0",
    "1588": "4:0",
    "1589": "5:0",
    "1590": "0:1",
    "1591": "1:1",
    "1592": "2:1",
    "1593": "3:1",
    "1594": "4:1",
    "1595": "5:1",
    "1596": "0:2",
    "1597": "1:2",
    "1598": "2:2",
    "1599": "3:2",
    "1600": "4:2",
    "1601": "5:2",
    "1602": "0:3",
    "1603": "1:3",
    "1604": "2:3",
    "1605": "3:3",
    "1606": "4:3",
    "1607": "5:3",
    "1608": "0:4",
    "1609": "1:4",
    "1610": "2:4",
    "1611": "3:4",
    "1612": "4:4",
    "1613": "5:4",
    "1614": "0:5",
    "1615": "1:5",
    "1616": "2:5",
    "1617": "3:5",
    "1618": "4:5",
    "1619": "5:5",
    "1620": "autre",
    "name": "Score correct",
    "group": "all|score|regular_play"
  },
  "432": {
    "1621": "1ère période",
    "1622": "2ème période",
    "1623": "3ème période",
    "1624": "égal",
    "name": "Période la plus prolifique au score",
    "group": "all|score|regular_play"
  },
  "433": {
    "1621": "1ère période",
    "1622": "2ème période",
    "1623": "3ème période",
    "1624": "égal",
    "name": "période dans laquelle {$competitor1} marque le plus de buts",
    "group": "all|score|regular_play"
  },
  "434": {
    "1621": "1ère période",
    "1622": "2ème période",
    "1623": "3ème période",
    "1624": "égal",
    "name": "période dans laquelle {$competitor2} marque le plus de buts",
    "group": "all|score|regular_play"
  },
  "435": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} qui gagne toutes les périodes",
    "group": "all|score|regular_play"
  },
  "436": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} qui gagne toutes les périodes",
    "group": "all|score|regular_play"
  },
  "437": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} qui gagne une des périodes",
    "group": "all|score|regular_play"
  },
  "438": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} qui gagne une des périodes",
    "group": "all|score|regular_play"
  },
  "439": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} qui marque dans toutes les périodes",
    "group": "all|score|regular_play"
  },
  "440": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} qui marque dans toutes les périodes",
    "group": "all|score|regular_play"
  },
  "441": {
    "74": "oui",
    "76": "non",
    "name": "Toutes les périodes {total} +",
    "group": "all|score|regular_play"
  },
  "442": {
    "74": "oui",
    "76": "non",
    "name": "Toutes les périodes {total} -",
    "group": "all|score|regular_play"
  },
  "443": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!periodnr} période - 1x2",
    "group": "all|score|period"
  },
  "444": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!periodnr} période - {!goalnr} but",
    "group": "all|score|period"
  },
  "445": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!periodnr} période - handicap {hcp}",
    "group": "all|score|period"
  },
  "446": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} période - total",
    "group": "all|score|period"
  },
  "447": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} période - {$competitor1} total",
    "group": "all|score|period"
  },
  "448": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!periodnr} période - {$competitor2} total",
    "group": "all|score|period"
  },
  "452": {
    "74": "oui",
    "76": "non",
    "name": "{!periodnr} période - les deux équipes qui marquent",
    "group": "all|score|period"
  },
  "453": {
    "784": "aucune",
    "788": "seulement {$competitor1}",
    "790": "seulement {$competitor2}",
    "792": "les deux équipes",
    "name": "{!periodnr} période - quelle équipe va marquer",
    "group": "all|score|period"
  },
  "454": {
    "74": "oui",
    "76": "non",
    "name": "{!periodnr} période - {$competitor1} cage inviolée",
    "group": "all|score|period"
  },
  "455": {
    "74": "oui",
    "76": "non",
    "name": "{!periodnr} période - {$competitor2} cage inviolée",
    "group": "all|score|period"
  },
  "456": {
    "1630": "0:0",
    "1631": "1:0",
    "1632": "2:0",
    "1633": "0:1",
    "1634": "1:1",
    "1635": "2:1",
    "1636": "0:2",
    "1637": "1:2",
    "1638": "2:2",
    "1639": "autre",
    "name": "{!periodnr} période - score correct",
    "group": "all|score|period"
  },
  "457": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!periodnr} période - dernière équipe qui va marquer",
    "group": "all|score|period"
  },
  "458": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!periodnr} période - quelle équipe va gagner le reste",
    "group": "all|score|period"
  },
  "459": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!periodnr} période - remboursé si match nul",
    "group": "all|score|period"
  },
  "460": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!periodnr} période - handicap",
    "group": "all|score|period"
  },
  "462": {
    "70": "impair",
    "72": "pair",
    "name": "{!periodnr} période - pair/impair",
    "group": "all|score|period"
  },
  "463": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "Prolongations - double chance",
    "group": "all|score|ot"
  },
  "464": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Prolongations - remboursé si match nul",
    "group": "all|score|ot"
  },
  "465": {
    "776": "Match nul",
    "778": "{$competitor2}",
    "name": "Prolongations - remboursé si victoire {$competitor1}",
    "group": "all|score|ot"
  },
  "466": {
    "780": "{$competitor1}",
    "782": "Match nul",
    "name": "Prolongations - remboursé si victoire {$competitor2}",
    "group": "all|score|ot"
  },
  "467": {
    "1640": "{$competitor1} avec un essai",
    "1641": "{$competitor1} avec une pénalité",
    "1642": "{$competitor1} avec un drop",
    "1643": "{$competitor2} avec un essai",
    "1644": "{$competitor2} avec une pénalité",
    "1645": "{$competitor2} avec un drop",
    "name": "{!scorenr} action de jeu qui marque des points",
    "group": "all|score|regular_play"
  },
  "472": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - atteindra en premier {pointnr} points",
    "group": "all|score|1st_half"
  },
  "473": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Essais 1x2",
    "group": "all|regular_play|tries"
  },
  "474": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "Essais double chance",
    "group": "all|regular_play|tries"
  },
  "475": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Essais remboursé si match nul",
    "group": "all|regular_play|tries"
  },
  "476": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "Essais handicap {hcp}",
    "group": "all|regular_play|tries"
  },
  "477": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Essais handicap",
    "group": "all|regular_play|tries"
  },
  "478": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total dessais",
    "group": "all|regular_play|tries"
  },
  "479": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total dessais",
    "group": "all|regular_play|tries"
  },
  "480": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total dessais",
    "group": "all|regular_play|tries"
  },
  "481": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair essais",
    "group": "all|regular_play|tries"
  },
  "482": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1ère mi-temps - Essais 1x2",
    "group": "all|1st_half|tries"
  },
  "483": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "1ère mi-temps - Essais double chance",
    "group": "all|1st_half|tries"
  },
  "484": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1ère mi-temps - Essais remboursé si match nul",
    "group": "all|1st_half|tries"
  },
  "485": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "1ère mi-temps - Essais handicap {hcp}",
    "group": "all|1st_half|tries"
  },
  "486": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "1ère mi-temps - Essais handicap",
    "group": "all|1st_half|tries"
  },
  "487": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - total dessais",
    "group": "all|1st_half|tries"
  },
  "488": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor1} total dessais",
    "group": "all|1st_half|tries"
  },
  "489": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1ère mi-temps - {$competitor2} total dessais",
    "group": "all|1st_half|tries"
  },
  "490": {
    "70": "impair",
    "72": "pair",
    "name": "1ère mi-temps - pair/impair Essais",
    "group": "all|1st_half|tries"
  },
  "491": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Quel joueur va gagner le reste du match",
    "group": "all|score|regular_play"
  },
  "492": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il une manche décisive ?",
    "group": "all|score|regular_play"
  },
  "493": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Manche handicap",
    "group": "all|score|regular_play"
  },
  "494": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total manches",
    "group": "all|score|regular_play"
  },
  "495": {
    "70": "impair",
    "72": "pair",
    "name": "Pair/Impair manches",
    "group": "all|score|regular_play"
  },
  "496": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Atteindra en premier {framenr} manches",
    "group": "all|score|regular_play"
  },
  "497": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Manches {fromframe} à {toframe} - vainqueur {frames} manches consécutives",
    "group": "all|score|x_frames"
  },
  "498": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Manches 1 à {framenr} - 1x2",
    "group": "all|score|x_frames"
  },
  "499": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} manche - vainqueur",
    "group": "all|score|frame"
  },
  "500": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!framenr} manche - point handicap",
    "group": "all|score|frame"
  },
  "501": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!framenr} manche - total points",
    "group": "all|score|frame"
  },
  "502": {
    "70": "impair",
    "72": "pair",
    "name": "{!framenr} manche - pair/impair",
    "group": "all|score|frame"
  },
  "503": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} manche - atteindra en premier {pointnr} points",
    "group": "all|score|frame"
  },
  "504": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} manche - joueur avec la meilleure série",
    "group": "all|frame|break"
  },
  "505": {
    "1667": "0-49",
    "1668": "50-99",
    "1669": "100-119",
    "1670": "120-146",
    "1671": "147+",
    "name": "{!framenr} manche - meilleure série",
    "group": "all|frame|break"
  },
  "506": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - série de 100 et +",
    "group": "all|frame|break"
  },
  "507": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - {$competitor1} série de 100 ou +",
    "group": "all|frame|break"
  },
  "508": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - {$competitor2} série de 100 ou +",
    "group": "all|frame|break"
  },
  "509": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - série de 50 et +",
    "group": "all|frame|break"
  },
  "510": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - {$competitor1} série de 50 ou +",
    "group": "all|frame|break"
  },
  "511": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - {$competitor2} série de 50 ou +",
    "group": "all|frame|break"
  },
  "512": {
    "74": "oui",
    "76": "non",
    "name": "{!framenr} manche - y aura-t-il une faute commise ?",
    "group": "all|score|frame"
  },
  "513": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} manche - joueur qui va empocher la {!xth} boule",
    "group": "all|score|frame"
  },
  "514": {
    "1672": "jaune",
    "1673": "verte",
    "1674": "marron",
    "1675": "bleue",
    "1676": "rose",
    "1677": "noire",
    "name": "{!framenr} manche - {!xth} couleur empochée",
    "group": "all|score|frame"
  },
  "515": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!framenr} manche - joueur qui empoche la dernière boule",
    "group": "all|score|frame"
  },
  "516": {
    "1678": "rouge",
    "1679": "jaune",
    "1680": "verte",
    "1681": "marron",
    "1682": "bleue",
    "1683": "rose",
    "1684": "noire",
    "1685": "faute",
    "name": "{!framenr} manche - derniers points marqués",
    "group": "all|score|frame"
  },
  "520": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!gamenr} manche - {!pointnr} point",
    "group": "all|score|game"
  },
  "525": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un 4ème set ?",
    "group": "all|score|regular_play"
  },
  "526": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un 5ème set ?",
    "group": "all|score|regular_play"
  },
  "527": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!setnr} set - handicap",
    "group": "all|score|set"
  },
  "528": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - total",
    "group": "all|score|set"
  },
  "529": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "{!periodnr} période - double chance",
    "group": "all|score|period"
  },
  "530": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - {!scorenr} score",
    "group": "all"
  },
  "538": {
    "1717": "Match nul",
    "name": "Face à face (1x2)",
    "group": "all"
  },
  "540": {
    "1718": "{$competitor1}/Match nul & oui",
    "1719": "{$competitor1}/Match nul & non",
    "1720": "{$competitor1}/{$competitor2} & oui",
    "1721": "{$competitor1}/{$competitor2} & non",
    "1722": "Match nul/{$competitor2} & oui",
    "1723": "Match nul/{$competitor2} & non",
    "name": "Double chance (match) & 1ère mi-temps les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "541": {
    "1718": "{$competitor1}/Match nul & oui",
    "1719": "{$competitor1}/Match nul & non",
    "1720": "{$competitor1}/{$competitor2} & oui",
    "1721": "{$competitor1}/{$competitor2} & non",
    "1722": "Match nul/{$competitor2} & oui",
    "1723": "Match nul/{$competitor2} & non",
    "name": "Double chance (match) & 2ème mi-temps les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "542": {
    "1718": "{$competitor1}/Match nul & oui",
    "1719": "{$competitor1}/Match nul & non",
    "1720": "{$competitor1}/{$competitor2} & oui",
    "1721": "{$competitor1}/{$competitor2} & non",
    "1722": "Match nul/{$competitor2} & oui",
    "1723": "Match nul/{$competitor2} & non",
    "name": "1ère mi-temps - double chance & les deux équipes qui marquent",
    "group": "all|combo|1st_half"
  },
  "543": {
    "78": "{$competitor1} & oui",
    "80": "{$competitor1} & non",
    "82": "Match nul & oui",
    "84": "Match nul & non",
    "86": "{$competitor2} & oui",
    "88": "{$competitor2} & non",
    "name": "2ème mi-temps - 1x2 & les deux équipes qui marquent",
    "group": "all|combo|2nd_half"
  },
  "544": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "2ème mi-temps - 1x2 & total",
    "group": "all|combo|2nd_half"
  },
  "545": {
    "1718": "{$competitor1}/Match nul & oui",
    "1719": "{$competitor1}/Match nul & non",
    "1720": "{$competitor1}/{$competitor2} & oui",
    "1721": "{$competitor1}/{$competitor2} & non",
    "1722": "Match nul/{$competitor2} & oui",
    "1723": "Match nul/{$competitor2} & non",
    "name": "2ème mi-temps - double chance & les deux équipes qui marquent",
    "group": "all|combo|2nd_half"
  },
  "546": {
    "1718": "{$competitor1}/Match nul & oui",
    "1719": "{$competitor1}/Match nul & non",
    "1720": "{$competitor1}/{$competitor2} & oui",
    "1721": "{$competitor1}/{$competitor2} & non",
    "1722": "Match nul/{$competitor2} & oui",
    "1723": "Match nul/{$competitor2} & non",
    "name": "Double chance & les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "547": {
    "1724": "{$competitor1}/Match nul & {total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "Match nul/{$competitor2} & {total} -",
    "1727": "{$competitor1}/Match nul & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "Match nul/{$competitor2} & {total} +",
    "name": "Double chance & total",
    "group": "all|regular_play|combo"
  },
  "548": {
    "1730": "1-2",
    "1731": "1-3",
    "1732": "1-4",
    "1733": "1-5",
    "1734": "1-6",
    "1735": "2-3",
    "1736": "2-4",
    "1737": "2-5",
    "1738": "2-6",
    "1739": "3-4",
    "1740": "3-5",
    "1741": "3-6",
    "1742": "4-5",
    "1743": "4-6",
    "1744": "5-6",
    "1745": "7+",
    "1804": "aucun but",
    "name": "Multi buts",
    "group": "all|score|regular_play"
  },
  "549": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "aucun but",
    "name": "{$competitor1} Multi buts",
    "group": "all|score|regular_play"
  },
  "550": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "aucun but",
    "name": "{$competitor2} Multi buts",
    "group": "all|score|regular_play"
  },
  "551": {
    "1750": "1:0, 2:0 ou 3:0",
    "1751": "0:1, 0:2 ou 0:3",
    "1752": "4:0, 5:0 ou 6:0",
    "1753": "0:4, 0:5 ou 0:6",
    "1754": "2:1, 3:1 ou 4:1",
    "1755": "1:2, 1:3 ou 1:4",
    "1756": "3:2, 4:2, 4:3 ou 5:1",
    "1757": "2:3, 2:4, 3:4 ou 1:5",
    "1758": "autre victoire domicile",
    "1759": "autre victoire extérieur",
    "1803": "Match nul",
    "name": "Multi scores",
    "group": "all|score|regular_play"
  },
  "552": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "aucun but",
    "name": "1ère mi-temps - multi buts",
    "group": "all|score|1st_half"
  },
  "553": {
    "1746": "1-2",
    "1747": "1-3",
    "1748": "2-3",
    "1749": "4+",
    "1805": "aucun but",
    "name": "2ème mi-temps - multi buts",
    "group": "all|score|2nd_half"
  },
  "554": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - kill pari remboursé si match nul",
    "group": "all|kills|map"
  },
  "555": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - kill handicap",
    "group": "all|kills|map"
  },
  "556": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} dragon",
    "group": "all|map|structures"
  },
  "557": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} baron",
    "group": "all|map|structures"
  },
  "558": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - {!xth} inhibiteur",
    "group": "all|map|structures"
  },
  "563": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Atteindra en premier {pointnr} points",
    "group": "all|score|regular_play"
  },
  "565": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "15 minutes - corners 1x2 de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "566": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "15 minutes - {!cornernr} corner de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "567": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "15 minutes - corner handicap de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "568": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 minutes - total corners de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "569": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 minutes - {$competitor1} total corners de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "570": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 minutes - {$competitor2} total corners de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "571": {
    "70": "impair",
    "72": "pair",
    "name": "15 minutes - pair/impair corners de {from} à {to}",
    "group": "all|15_min|corners"
  },
  "572": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "10 minutes - corners 1x2 de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "573": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "10 minutes - {!cornernr} corner de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "574": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "10 minutes - corner handicap de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "575": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 minutes - total corners de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "576": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 minutes - {$competitor1} total corners de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "577": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 minutes - {$competitor2} total corners de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "578": {
    "70": "impair",
    "72": "pair",
    "name": "10 minutes - pair/impair corners de {from} à {to}",
    "group": "all|10_min|corners"
  },
  "579": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "5 minutes - corners 1x2 de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "580": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "5 minutes - {!cornernr} corner de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "581": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "5 minutes - corner handicap de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "582": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 minutes - total corners de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "583": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 minutes - {$competitor1} total corners de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "584": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 minutes - {$competitor2} total corners de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "585": {
    "70": "impair",
    "72": "pair",
    "name": "5 minutes - pair/impair corners de {from} à {to}",
    "group": "all|5_min|corners"
  },
  "586": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "15 minutes - cartons 1x2 de {from} à {to}",
    "group": "all|15_min|bookings"
  },
  "587": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "15 minutes - total cartons de {from} à {to}",
    "group": "all|15_min|bookings"
  },
  "588": {
    "74": "oui",
    "76": "non",
    "name": "15 minutes - expulsion de {from} à {to}",
    "group": "all|15_min|bookings"
  },
  "589": {
    "74": "oui",
    "76": "non",
    "name": "15 minutes - {$competitor1} expulsion de {from} à {to}",
    "group": "all|15_min|bookings"
  },
  "590": {
    "74": "oui",
    "76": "non",
    "name": "15 minutes - {$competitor2} expulsion de {from} à {to}",
    "group": "all|15_min|bookings"
  },
  "591": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "10 minutes - cartons 1x2 de {from} à {to}",
    "group": "all|10_min|bookings"
  },
  "592": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "10 minutes - total cartons de {from} à {to}",
    "group": "all|10_min|bookings"
  },
  "593": {
    "74": "oui",
    "76": "non",
    "name": "10 minutes - expulsion de {from} à {to}",
    "group": "all|10_min|bookings"
  },
  "594": {
    "74": "oui",
    "76": "non",
    "name": "10 minutes - {$competitor1} expulsion de {from} à {to}",
    "group": "all|10_min|bookings"
  },
  "595": {
    "74": "oui",
    "76": "non",
    "name": "10 minutes - {$competitor2} expulsion de {from} à {to}",
    "group": "all|10_min|bookings"
  },
  "596": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "5 minutes - cartons 1x2 de {from} à {to}",
    "group": "all|5_min|bookings"
  },
  "597": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "5 minutes - total cartons de {from} à {to}",
    "group": "all|5_min|bookings"
  },
  "598": {
    "74": "oui",
    "76": "non",
    "name": "5 minutes - expulsion de {from} à {to}",
    "group": "all|5_min|bookings"
  },
  "599": {
    "74": "oui",
    "76": "non",
    "name": "5 minutes - {$competitor1} expulsion de {from} à {to}",
    "group": "all|5_min|bookings"
  },
  "600": {
    "74": "oui",
    "76": "non",
    "name": "5 minutes - {$competitor2} expulsion de {from} à {to}",
    "group": "all|5_min|bookings"
  },
  "601": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Atteindra en premier {cornernr} corners",
    "group": "all|regular_play|corners"
  },
  "602": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ère mi-temps - atteindra en premier {cornernr} corners",
    "group": "all|1st_half|corners"
  },
  "603": {
    "1797": "en haut à gauche",
    "1798": "en bas à gauche",
    "1799": "en haut au centre",
    "1800": "en bas au centre",
    "1801": "en haut à droite",
    "1802": "en bas à droite",
    "name": "{!goalnr} but - zone de frappe",
    "group": "all|misc"
  },
  "604": {
    "74": "oui",
    "76": "non",
    "name": "{!penaltynr} penalty marqué",
    "group": "all|score|regular_play"
  },
  "605": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - total",
    "group": "all|score|innings"
  },
  "606": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total",
    "group": "all|score|innings"
  },
  "607": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total",
    "group": "all|score|innings"
  },
  "608": {
    "70": "impair",
    "72": "pair",
    "name": "{!inningnr} manche - pair/impair",
    "group": "all|score|innings"
  },
  "609": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Equipe avec le plus de points en un quart-temps",
    "group": "all|score|regular_play"
  },
  "610": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1x2 (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "611": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!quarternr} quart-temps - 1x2 (inclus prolongations)",
    "group": "all|score|quarter_incl_ot"
  },
  "612": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Remboursé si match nul (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "613": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quart-temps - remboursé si match nul (inclus prolongations)",
    "group": "all|score|quarter_incl_ot"
  },
  "614": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!quarternr} quart-temps - handicap (inclus prolongations)",
    "group": "all|score|quarter_incl_ot"
  },
  "615": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} quart-temps - total (inclus prolongations)",
    "group": "all|score|quarter_incl_ot"
  },
  "616": {
    "70": "impair",
    "72": "pair",
    "name": "{$competitor1} pair/impair (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "617": {
    "70": "impair",
    "72": "pair",
    "name": "{$competitor2} pair/impair (inclus prolongations)",
    "group": "all|score|incl_ot"
  },
  "618": {
    "70": "impair",
    "72": "pair",
    "name": "1ère mi-temps - {$competitor1} pair/impair",
    "group": "all|score|1st_half"
  },
  "619": {
    "70": "impair",
    "72": "pair",
    "name": "1ère mi-temps - {$competitor2} pair/impair",
    "group": "all|score|1st_half"
  },
  "620": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - atteindra en premier {roundnr} manches",
    "group": "all|score|map"
  },
  "621": {
    "70": "impair",
    "72": "pair",
    "name": "{!mapnr} map - pair/impair manches (inclus prolongations)",
    "group": "all|score|map_incl_ot"
  },
  "622": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map - total de tirs à la tête (inclus prolongations)",
    "group": "all|map_incl_ot|kills"
  },
  "623": {
    "74": "oui",
    "76": "non",
    "name": "{!mapnr} map - y aura-t-il un ace (inclus prolongations) ?",
    "group": "all|map_incl_ot|kills"
  },
  "626": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map manche {roundnr} - total kills",
    "group": "all|kills|round"
  },
  "627": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map manche {roundnr} - kill handicap",
    "group": "all|kills|round"
  },
  "628": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map manche {roundnr} - {!killnr} kill",
    "group": "all|kills|round"
  },
  "629": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map manche {roundnr} - {$competitor1} total kills",
    "group": "all|kills|round"
  },
  "630": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map manche {roundnr} - {$competitor2} total kills",
    "group": "all|kills|round"
  },
  "631": {
    "74": "oui",
    "76": "non",
    "name": "{!mapnr} map manche {roundnr} - bombe plantée",
    "group": "all|round|bomb"
  },
  "632": {
    "74": "oui",
    "76": "non",
    "name": "{!mapnr} map manche {roundnr} - bombe désamorcée",
    "group": "all|round|bomb"
  },
  "634": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Equipe avec la mi-temps la plus prolifique au score",
    "group": "all|score|regular_play"
  },
  "638": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {%player} total",
    "group": "all"
  },
  "639": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total de Four",
    "group": "all"
  },
  "640": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total de Six",
    "group": "all"
  },
  "641": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor1} élimination",
    "group": "all"
  },
  "642": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor2} élimination",
    "group": "all"
  },
  "643": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {%player} total de Four",
    "group": "all"
  },
  "644": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {%player} total de Six",
    "group": "all"
  },
  "645": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche Série de lancers {overnr} - 1x2",
    "group": "all"
  },
  "646": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Equipe avec le plus haut score à la {!dismissalnr} élimination",
    "group": "all"
  },
  "647": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus de Four",
    "group": "all"
  },
  "648": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus de Six",
    "group": "all"
  },
  "649": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total éliminations",
    "group": "all"
  },
  "650": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total éliminations",
    "group": "all"
  },
  "651": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} manche - {%player} méthode délimination",
    "group": "all"
  },
  "652": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor1} balle expédiée hors-limite",
    "group": "all"
  },
  "653": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche Série de lancers {overnr} - {$competitor2} balle expédiée hors-limite",
    "group": "all"
  },
  "654": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total run outs",
    "group": "all"
  },
  "655": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total extras",
    "group": "all"
  },
  "656": {
    "1818": "{%player1}",
    "1819": "Match nul",
    "1820": "{%player2}",
    "name": "{!inningnr} manche - {!dismissalnr} partenariat 1x2",
    "group": "all"
  },
  "657": {
    "1821": "{%player1}",
    "1822": "{%player2}",
    "name": "{!inningnr} manche - {!dismissalnr} batteur out",
    "group": "all"
  },
  "658": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total de Four",
    "group": "all"
  },
  "659": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total de Four",
    "group": "all"
  },
  "660": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total de Six",
    "group": "all"
  },
  "661": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total de Six",
    "group": "all"
  },
  "662": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {%player} va marquer {milestone}",
    "group": "all"
  },
  "663": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers 0 à {overnr} - {$competitor1} total des éliminations",
    "group": "all"
  },
  "664": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche Série de lancers 0 à {overnr} - {$competitor2} total des éliminations",
    "group": "all"
  },
  "665": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!daynr} jour session {sessionnr} - total",
    "group": "all"
  },
  "666": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total extras",
    "group": "all"
  },
  "667": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total extras",
    "group": "all"
  },
  "668": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total run outs",
    "group": "all"
  },
  "669": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total run outs",
    "group": "all"
  },
  "670": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total dans la série de lancers la plus prolifique au score",
    "group": "all"
  },
  "671": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total dans la série de lancers la plus prolifique au score",
    "group": "all"
  },
  "680": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus dextras",
    "group": "all"
  },
  "681": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus de run outs",
    "group": "all"
  },
  "682": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total dans la série de lancers la plus prolifique au score",
    "group": "all"
  },
  "686": {
    "1818": "{%player1}",
    "1819": "Match nul",
    "1820": "{%player2}",
    "name": "Batteur face à face (1x2)",
    "group": "all"
  },
  "687": {
    "1818": "{%player1}",
    "1819": "Match nul",
    "1820": "{%player2}",
    "name": "Lanceur face à face (1x2)",
    "group": "all"
  },
  "688": {
    "1818": "{%player1}",
    "1819": "Match nul",
    "1820": "{%player2}",
    "name": "Joueur polyvalent face à face (1x2)",
    "group": "all"
  },
  "689": {
    "1818": "{%player1}",
    "1819": "Match nul",
    "1820": "{%player2}",
    "name": "Gardien face à face (1x2)",
    "group": "all"
  },
  "690": {
    "70": "impair",
    "72": "pair",
    "name": "{!inningnr} manche - {$competitor1} pair/impair",
    "group": "all"
  },
  "691": {
    "70": "impair",
    "72": "pair",
    "name": "{!inningnr} manche - {$competitor2} pair/impair",
    "group": "all"
  },
  "692": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor1} finit avec une balle expédiée hors-limite",
    "group": "all"
  },
  "693": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor2} finit avec une balle expédiée hors-limite",
    "group": "all"
  },
  "694": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Quelle équipe va gagner le toss",
    "group": "all"
  },
  "695": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total des ducks",
    "group": "all"
  },
  "696": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total des wides",
    "group": "all"
  },
  "697": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total des éliminations",
    "group": "all"
  },
  "698": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Equipe avec le meilleur batteur",
    "group": "all"
  },
  "699": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Equipe avec le meilleur lanceur",
    "group": "all"
  },
  "700": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - Un des joueurs va marquer {milestone}",
    "group": "all"
  },
  "701": {
    "74": "oui",
    "76": "non",
    "name": "Un des joueurs va marquer {milestone}",
    "group": "all"
  },
  "702": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Meilleur batteur total",
    "group": "all"
  },
  "703": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rabbit total",
    "group": "all"
  },
  "704": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor1} nombre de balles injouables",
    "group": "all"
  },
  "705": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor2} nombre de balles injouables",
    "group": "all"
  },
  "706": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total ducks",
    "group": "all"
  },
  "707": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total ducks",
    "group": "all"
  },
  "708": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {%player} total des éliminations",
    "group": "all"
  },
  "709": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total performance du joueur",
    "group": "all"
  },
  "710": {
    "1813": "{$competitor1}",
    "1814": "Ni l une ni l autre",
    "1815": "{$competitor2}",
    "name": "Quelle équipe va gagner le toss et le match",
    "group": "all"
  },
  "711": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche - 1x2",
    "group": "all"
  },
  "712": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus darrêts de volée du gardien",
    "group": "all"
  },
  "713": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus darrêts de volée",
    "group": "all"
  },
  "714": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Le plus de stumpings",
    "group": "all"
  },
  "717": {
    "1816": "{%player1} ({+hcp})",
    "1817": "{%player2} ({-hcp})",
    "name": "Batteur face à face (handicap)",
    "group": "all"
  },
  "718": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} manche - {!dismissalnr} méthode délimination (étendu)",
    "group": "all"
  },
  "723": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un rampage ?",
    "group": "all|regular_play|kills"
  },
  "724": {
    "74": "oui",
    "76": "non",
    "name": "Y aura-t-il un ultra kill ?",
    "group": "all|regular_play|kills"
  },
  "725": {
    "1831": "00:00 - {(minute-1)}:59",
    "1832": "{minute}:00+",
    "name": "{!mapnr} map - durée",
    "group": "all|map|progress"
  },
  "726": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map - total kills",
    "group": "all|kills|map"
  },
  "727": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map - total égides",
    "group": "all|map|structures"
  },
  "728": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map - total tours",
    "group": "all|map|structures"
  },
  "729": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - égide handicap",
    "group": "all|map|structures"
  },
  "730": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!mapnr} map - tour handicap",
    "group": "all|map|structures"
  },
  "731": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - atteindra en premier {xth} kills",
    "group": "all|kills|map"
  },
  "732": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - atteindra en premier {xth} valeur nette",
    "group": "all|map|progress"
  },
  "733": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - atteindra en premier le niveau {xth}",
    "group": "all|map|progress"
  },
  "734": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!mapnr} map 10 Minutes - total kills de {from} à {to}",
    "group": "all|10_min|kills"
  },
  "736": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map 1ère mi-temps - vainqueur",
    "group": "all|score|map_1st_half"
  },
  "737": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Maximum de runs consécutifs par une des équipes",
    "group": "all|score|regular_play"
  },
  "738": {
    "1823": "haut de la 9ème manche",
    "1824": "bas de la 9ème manche",
    "1825": "une manche supplémentaire",
    "name": "Quand le match sera-t-il conclu ?",
    "group": "all|score|regular_play"
  },
  "739": {
    "1826": "{!inningnr} manche",
    "1828": "{!(inningnr+1)} manche",
    "1829": "{!(inningnr+2)} manche",
    "1830": "autre manche ou aucun run",
    "name": "Quand sera marqué le {!runnr} run (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "740": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total manche la moins prolifique au score",
    "group": "all|score|regular_play"
  },
  "741": {
    "74": "oui",
    "76": "non",
    "name": "Les deux équipes au-dessus de {total} (inclus manches supplémentaires)",
    "group": "all|score|incl_ei"
  },
  "742": {
    "1529": "{$competitor1} & {$competitor1}",
    "1530": "Match nul & {$competitor1}",
    "1531": "{$competitor2} & {$competitor1}",
    "1532": "{$competitor1} & Match nul",
    "1533": "Match nul & Match nul",
    "1534": "{$competitor2} & Match nul",
    "1535": "{$competitor1} & {$competitor2}",
    "1536": "Match nul & {$competitor2}",
    "1537": "{$competitor2} & {$competitor2}",
    "name": "{innings} premières manches 1x2 & 1x2 (inclus manches supplémentaires)",
    "group": "all|combo|incl_ei"
  },
  "743": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Manches {from} à {to} - 1x2",
    "group": "all|score|3_innings"
  },
  "744": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Manches {from} à {to} - handicap",
    "group": "all|score|3_innings"
  },
  "745": {
    "70": "impair",
    "72": "pair",
    "name": "Manches {from} à {to} - pair/impair",
    "group": "all|score|3_innings"
  },
  "746": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "{!inningnr} manche - handicap",
    "group": "all|score|inning"
  },
  "747": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} total",
    "group": "all|score|inning"
  },
  "748": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} total",
    "group": "all|score|inning"
  },
  "749": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor1} qui marque",
    "group": "all|score|inning"
  },
  "750": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor2} qui marque",
    "group": "all|score|inning"
  },
  "751": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - les deux équipes qui marquent",
    "group": "all|score|inning"
  },
  "752": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} manche - {!xth} autel",
    "group": "all|map|structures"
  },
  "753": {
    "9": "{$competitor1} ou Match nul",
    "10": "{$competitor1} ou {$competitor2}",
    "11": "Match nul ou {$competitor2}",
    "name": "{!quarternr} quart-temps - double chance",
    "group": "all|score|quarter"
  },
  "754": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!quarternr} quart-temps - quelle équipe gagne le reste",
    "group": "all|score|quarter"
  },
  "756": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} quart-temps - total {$competitor1}",
    "group": "all|score|quarter"
  },
  "757": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!quarternr} quart-temps - total {$competitor2}",
    "group": "all|score|quarter"
  },
  "797": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total équipes à domicile",
    "group": "all|matchday"
  },
  "798": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total équipes à lextérieur",
    "group": "all|matchday"
  },
  "799": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total",
    "group": "all|matchday"
  },
  "800": {
    "1833": "les équipes à domicile",
    "1834": "Egalité",
    "1835": "les équipes à l extérieur",
    "name": "{$event} journée {matchday} - le plus de buts pour les équipes à domicile ou à lextérieur",
    "group": "all|matchday"
  },
  "801": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total victoires équipe à domicile",
    "group": "all|matchday"
  },
  "802": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total matchs nuls",
    "group": "all|matchday"
  },
  "803": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$event} journée {matchday} - total victoires équipe à lextérieur",
    "group": "all|matchday"
  },
  "815": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!mapnr} map - Assistance - Remboursé si Match nul",
    "group": "all"
  },
  "816": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} manches - {$competitor1} {!dismissalnr} méthode délimination (étendu)",
    "group": "all"
  },
  "817": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} manches - {$competitor2} {!dismissalnr} méthode délimination (étendu)",
    "group": "all"
  },
  "818": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/Match nul & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "Match nul/{$competitor1} & {total} -",
    "1840": "Match nul/Match nul & {total} -",
    "1841": "Match nul/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/Match nul & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & {total} +",
    "1846": "{$competitor1}/Match nul & {total} +",
    "1847": "{$competitor1}/{$competitor2} & {total} +",
    "1848": "Match nul/{$competitor1} & {total} +",
    "1849": "Match nul/Match nul & {total} +",
    "1850": "Match nul/{$competitor2} & {total} +",
    "1851": "{$competitor2}/{$competitor1} & {total} +",
    "1852": "{$competitor2}/Match nul & {total} +",
    "1853": "{$competitor2}/{$competitor2} & {total} +",
    "name": "Mi-temps/fin de match & total",
    "group": "all|regular_play|combo"
  },
  "819": {
    "1836": "{$competitor1}/{$competitor1} & {total} -",
    "1837": "{$competitor1}/Match nul & {total} -",
    "1838": "{$competitor1}/{$competitor2} & {total} -",
    "1839": "Match nul/{$competitor1} & {total} -",
    "1840": "Match nul/Match nul & {total} -",
    "1841": "Match nul/{$competitor2} & {total} -",
    "1842": "{$competitor2}/{$competitor1} & {total} -",
    "1843": "{$competitor2}/Match nul & {total} -",
    "1844": "{$competitor2}/{$competitor2} & {total} -",
    "1845": "{$competitor1}/{$competitor1} & {total} +",
    "1846": "{$competitor1}/Match nul & {total} +",
    "1847": "{$competitor1}/{$competitor2} & {total} +",
    "1848": "Match nul/{$competitor1} & {total} +",
    "1849": "Match nul/Match nul & {total} +",
    "1850": "Match nul/{$competitor2} & {total} +",
    "1851": "{$competitor2}/{$competitor1} & {total} +",
    "1852": "{$competitor2}/Match nul & {total} +",
    "1853": "{$competitor2}/{$competitor2} & {total} +",
    "name": "Mi-temps/fin de match & total 1ere mi-temps",
    "group": "all|regular_play|combo"
  },
  "820": {
    "1854": "Match nul/Match nul & 0",
    "1855": "{$competitor1}/{$competitor1} & 1",
    "1856": "Match nul/{$competitor1} & 1",
    "1857": "Match nul/{$competitor2} & 1",
    "1858": "{$competitor2}/{$competitor2} & 1",
    "1859": "{$competitor1}/{$competitor1} & 2",
    "1860": "{$competitor1}/Match nul & 2",
    "1861": "Match nul/{$competitor1} & 2",
    "1862": "Match nul/Match nul & 2",
    "1863": "Match nul/{$competitor2} & 2",
    "1864": "{$competitor2}/Match nul & 2",
    "1865": "{$competitor2}/{$competitor2} & 2",
    "1866": "{$competitor1}/{$competitor1} & 3",
    "1867": "{$competitor1}/{$competitor2} & 3",
    "1868": "Match nul/{$competitor1} & 3",
    "1869": "Match nul/{$competitor2} & 3",
    "1870": "{$competitor2}/{$competitor1} & 3",
    "1871": "{$competitor2}/{$competitor2} & 3",
    "1872": "{$competitor1}/{$competitor1} & 4",
    "1873": "{$competitor1}/Match nul & 4",
    "1874": "{$competitor1}/{$competitor2} & 4",
    "1875": "Match nul/{$competitor1} & 4",
    "1876": "Match nul/Match nul & 4",
    "1877": "Match nul/{$competitor2} & 4",
    "1878": "{$competitor2}/{$competitor1} & 4",
    "1879": "{$competitor2}/Match nul & 4",
    "1880": "{$competitor2}/{$competitor2} & 4",
    "1881": "{$competitor1}/{$competitor1} & 5 ou +",
    "1882": "{$competitor1}/Match nul & 5 ou +",
    "1883": "{$competitor1}/{$competitor2} & 5 ou +",
    "1884": "Match nul/{$competitor1} & 5 ou +",
    "1885": "Match nul/Match nul & 5 ou +",
    "1886": "Match nul/{$competitor2} & 5 ou +",
    "1887": "{$competitor2}/{$competitor1} & 5 ou +",
    "1888": "{$competitor2}/Match nul & 5 ou +",
    "1889": "{$competitor2}/{$competitor2} & 5 ou +",
    "name": "Mi-temps/fin de match & nombre exaxt de buts",
    "group": "all|regular_play|combo"
  },
  "821": {
    "70": "impair",
    "72": "pair",
    "name": "Tirage Somme Pair/Impair",
    "group": "all"
  },
  "822": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Tirage Somme Total",
    "group": "all"
  },
  "824": {
    "70": "impair",
    "72": "pair",
    "name": "Boule bonus Pair/Impair",
    "group": "all"
  },
  "825": {
    "70": "impair",
    "72": "pair",
    "name": "Boule bonus Somme Pair/Impair",
    "group": "all"
  },
  "826": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Boule bonus Total",
    "group": "all"
  },
  "827": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Boule bonus Somme Total",
    "group": "all"
  },
  "828": {
    "74": "oui",
    "76": "non",
    "name": "Boule bonus Chiffre unique",
    "group": "all"
  },
  "829": {
    "74": "oui",
    "76": "non",
    "name": "Boule bonus égal à une des boules régulières",
    "group": "all"
  },
  "831": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Tirage Somme Total (inclus Boule bonus)",
    "group": "all"
  },
  "835": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor1} windex",
    "group": "all"
  },
  "836": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor2} windex",
    "group": "all"
  },
  "837": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor1}/{$competitor2} supremacy",
    "group": "all"
  },
  "838": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor2}/{$competitor1} supremacy",
    "group": "all"
  },
  "839": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} total spread",
    "group": "all"
  },
  "840": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} total spread",
    "group": "all"
  },
  "841": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} total spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "842": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} total spread at {!dismissalnr} dismissal",
    "group": "all"
  },
  "843": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} total spread",
    "group": "all"
  },
  "844": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} total spread",
    "group": "all"
  },
  "845": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} total spread",
    "group": "all"
  },
  "846": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} total spread",
    "group": "all"
  },
  "847": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} total spread",
    "group": "all"
  },
  "850": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagnera exactement 1 set",
    "group": "all|score|regular_play"
  },
  "851": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagnera exactement 1 set",
    "group": "all|score|regular_play"
  },
  "852": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagnera exactement 2 sets",
    "group": "all|score|regular_play"
  },
  "853": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagnera exactement 2 sets",
    "group": "all|score|regular_play"
  },
  "854": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} ou {total} +",
    "group": "all|regular_play|combo"
  },
  "855": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} ou {total} -",
    "group": "all|regular_play|combo"
  },
  "856": {
    "74": "oui",
    "76": "non",
    "name": "Nul ou {total} +",
    "group": "all|regular_play|combo"
  },
  "857": {
    "74": "oui",
    "76": "non",
    "name": "Nul ou {total} -",
    "group": "all|regular_play|combo"
  },
  "858": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} ou {total} +",
    "group": "all|regular_play|combo"
  },
  "859": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} ou {total} -",
    "group": "all|regular_play|combo"
  },
  "860": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} ou les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "861": {
    "74": "oui",
    "76": "non",
    "name": "Nul ou les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "862": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} ou les deux équipes qui marquent",
    "group": "all|regular_play|combo"
  },
  "863": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} ou une des cages reste inviolée",
    "group": "all|regular_play|combo"
  },
  "864": {
    "74": "oui",
    "76": "non",
    "name": "Nul ou une des cages reste inviolée",
    "group": "all|regular_play|combo"
  },
  "865": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} ou une des cages reste inviolée",
    "group": "all|regular_play|combo"
  },
  "870": {
    "1893": "Autre",
    "name": "Exacta",
    "group": "all"
  },
  "871": {
    "1893": "Autre",
    "name": "Quinella",
    "group": "all"
  },
  "872": {
    "1893": "Autre",
    "name": "Trifecta",
    "group": "all"
  },
  "873": {
    "1893": "Autre",
    "name": "Trio",
    "group": "all"
  },
  "875": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor1} total à la {!dismissalnr} élimination",
    "group": "all"
  },
  "876": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor2} total à la {!dismissalnr} élimination",
    "group": "all"
  },
  "877": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor1} total",
    "group": "all"
  },
  "878": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {$competitor2} total",
    "group": "all"
  },
  "879": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} gagne",
    "group": "all|score|regular_play"
  },
  "880": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} gagne",
    "group": "all|score|regular_play"
  },
  "881": {
    "74": "oui",
    "76": "non",
    "name": "Une des équipes gagne",
    "group": "all|score|regular_play"
  },
  "882": {
    "74": "oui",
    "76": "non",
    "name": "{%player} qui marque (prolongations incluses)",
    "group": "all|scorers|incl_ot"
  },
  "883": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 minute - total de {from} à {to}",
    "group": "all|score|rapid_market"
  },
  "884": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 minute - total Corners de {from} à {to}",
    "group": "all|corners|rapid_market"
  },
  "885": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 minute - total Cartons de {from} à {to}",
    "group": "all|bookings|rapid_market"
  },
  "886": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 minute - total Hors-jeux de {from} à {to}",
    "group": "all|rapid_market|offsides"
  },
  "887": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "1 minute - total Penalties accordés de {from} à {to}",
    "group": "all|rapid_market|penalties"
  },
  "888": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & Match nul",
    "1896": "{%player} & {$competitor2}",
    "1897": "autre",
    "name": "Buteur dans le match & 1x2",
    "group": "all|regular_play|combo"
  },
  "889": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "autre",
    "name": "Buteur dans le match & score exact",
    "group": "all|regular_play|combo"
  },
  "890": {
    "1898": "{%player} & 1:0",
    "1899": "{%player} & 2:0",
    "1900": "{%player} & 3:0",
    "1901": "{%player} & 4:0",
    "1902": "{%player} & 2:1",
    "1903": "{%player} & 3:1",
    "1904": "{%player} & 4:1",
    "1905": "{%player} & 3:2",
    "1906": "{%player} & 4:2",
    "1907": "{%player} & 4:3",
    "1908": "{%player} & 0:1",
    "1909": "{%player} & 0:2",
    "1910": "{%player} & 0:3",
    "1911": "{%player} & 0:4",
    "1912": "{%player} & 1:2",
    "1913": "{%player} & 1:3",
    "1914": "{%player} & 1:4",
    "1915": "{%player} & 2:3",
    "1916": "{%player} & 2:4",
    "1917": "{%player} & 3:4",
    "1918": "{%player} & 1:1",
    "1919": "{%player} & 2:2",
    "1920": "{%player} & 3:3",
    "1921": "{%player} & 4:4",
    "1922": "autre",
    "name": "{!goalnr} buteur & score exact",
    "group": "all|regular_play|combo"
  },
  "891": {
    "1894": "{%player} & {$competitor1}",
    "1895": "{%player} & Match nul",
    "1896": "{%player} & {$competitor2}",
    "1897": "autre",
    "name": "{!goalnr} buteur & 1x2",
    "group": "all|regular_play|combo"
  },
  "894": {
    "1923": "7:0",
    "1924": "7:1",
    "1925": "7:2",
    "1926": "7:3",
    "1927": "7:4",
    "1928": "7:5",
    "1929": "autre {$competitor1} victoire",
    "1930": "0:7",
    "1931": "1:7",
    "1932": "2:7",
    "1933": "3:7",
    "1934": "4:7",
    "1935": "5:7",
    "1936": "autre {$competitor2} victoire",
    "name": "{!setnr} set jeu décisif - correct score",
    "group": "all|score|tiebreak"
  },
  "895": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set jeu décisif - nombre de points",
    "group": "all|score|tiebreak"
  },
  "896": {
    "1937": "tir",
    "1938": "tête",
    "1939": "but contre son camp",
    "1940": "pénalty",
    "1941": "coup-franc",
    "1942": "aucun",
    "name": "{!scorenr} manière de marquer",
    "group": "all|score|regular_play"
  },
  "897": {
    "462": "0:0",
    "464": "1:1",
    "466": "2:2",
    "468": "1:0",
    "470": "2:0",
    "472": "2:1",
    "474": "0:1",
    "476": "0:2",
    "478": "1:2",
    "480": "autre",
    "name": "Prolongations - score correct",
    "group": "all|score|ot"
  },
  "902": {
    "1640": "{$competitor1} avec un essai",
    "1641": "{$competitor1} avec une pénalité",
    "1642": "{$competitor1} avec un drop",
    "1643": "{$competitor2} avec un essai",
    "1644": "{$competitor2} avec une pénalité",
    "1645": "{$competitor2} avec un drop",
    "name": "Next scoring play",
    "group": "all|score|regular_play"
  },
  "903": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Next score (incl. overtime)",
    "group": "all|score|incl_ot"
  },
  "904": {
    "1945": "touchdown",
    "1946": "field goal",
    "1947": "safety",
    "1948": "aucun",
    "name": "Prochaine manière de marquer (prolongation incl.)",
    "group": "all|score|incl_ot"
  },
  "905": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "1ere mi-temps - prochain but",
    "group": "all|score|1st_half"
  },
  "911": {
    "74": "oui",
    "76": "non",
    "name": "Est ce que tout les rounds vont avoir lieu ?",
    "group": "all"
  },
  "914": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de yards gagnés à la passe",
    "group": "all"
  },
  "915": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de passes réussies",
    "group": "all"
  },
  "916": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre dessais par passes",
    "group": "all"
  },
  "917": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de ballon portés",
    "group": "all"
  },
  "918": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de yards gagnés au sol",
    "group": "all"
  },
  "919": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de yards gagné à la réception",
    "group": "all"
  },
  "920": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de réceptions",
    "group": "all"
  },
  "921": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de points",
    "group": "all|score|incl_ot|player_props"
  },
  "922": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de passes décisives",
    "group": "all|incl_ot|player_props|assist"
  },
  "923": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de rebonds",
    "group": "all|incl_ot|player_props|rebound"
  },
  "924": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de tirs à 3-points réussis",
    "group": "all|score|incl_ot|player_props"
  },
  "925": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de retrait sur 3 prises (strikeout)",
    "group": "all|incl_ei"
  },
  "926": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "nombre de buts (bases)",
    "group": "all|incl_ei"
  },
  "927": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total batter runs + runs batted in (incl. extra innings)",
    "group": "all|incl_ei"
  },
  "928": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} nombre de point mérité",
    "group": "all|incl_ei"
  },
  "929": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total saves (incl. overtime)",
    "group": "all"
  },
  "931": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre déssais (touchdowns)(prolongations incluses)",
    "group": "all|incl_ot"
  },
  "932": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de transformations (field goals) réussies (prolongations incluses)",
    "group": "all|incl_ot"
  },
  "933": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de renversements (turnovers) (prolongations incluses)",
    "group": "all"
  },
  "934": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de plaquage sur le quaterback (sack)(prolongations incluses)",
    "group": "all"
  },
  "940": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!fieldgoalnr} nombre de transformations (field goal) réussies (prolongations incluses)",
    "group": "all"
  },
  "956": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!timeoutnr} temps mort",
    "group": "all"
  },
  "959": {
    "1961": "tentative de coup de pied au but (Field goal)",
    "1962": "essai offensif (offensive touchdown)",
    "1963": "Coup de pied de dégagement (punt)",
    "1964": "perte de possession (turnover)",
    "1965": "safety",
    "name": "{!drivenr} série offensive (drive) - résultat",
    "group": "all"
  },
  "960": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quart-temps - dernier point",
    "group": "all"
  },
  "961": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!freethrownr} lancer franc réussi",
    "group": "all"
  },
  "962": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} nombre maximum de points marqués consécutivement",
    "group": "all"
  },
  "963": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} nombre maximum de points marqués consécutivement",
    "group": "all"
  },
  "964": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre maximum de points marqués consécutivement pour lune des équipes",
    "group": "all"
  },
  "965": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} de mener de {points}",
    "group": "all"
  },
  "966": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} de mener de {points}",
    "group": "all"
  },
  "967": {
    "74": "oui",
    "76": "non",
    "name": "Une des équipes de mener de {points}",
    "group": "all"
  },
  "970": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Total sixes spread",
    "group": "all"
  },
  "971": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Multi sixes spread",
    "group": "all"
  },
  "972": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor1} 10/3 sixes head2head spread",
    "group": "all"
  },
  "973": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor2} 10/3 sixes head2head spread",
    "group": "all"
  },
  "974": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} total sixes spread",
    "group": "all"
  },
  "975": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} total sixes spread",
    "group": "all"
  },
  "976": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Total fours spread",
    "group": "all"
  },
  "977": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Multi fours spread",
    "group": "all"
  },
  "978": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} total fours spread",
    "group": "all"
  },
  "979": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} total fours spread",
    "group": "all"
  },
  "980": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor1} joy of six spread",
    "group": "all"
  },
  "981": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{$competitor2} joy of six spread",
    "group": "all"
  },
  "982": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Total {upsnr} ups spread",
    "group": "all"
  },
  "984": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor1} total {upsnr} ups spread",
    "group": "all"
  },
  "985": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {$competitor2} total {upsnr} ups spread",
    "group": "all"
  },
  "988": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} supremacy spread",
    "group": "all"
  },
  "989": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} supremacy spread",
    "group": "all"
  },
  "992": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Total wides spread",
    "group": "all"
  },
  "993": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Multi wides spread",
    "group": "all"
  },
  "994": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings {!overnr} over - total runs spread",
    "group": "all"
  },
  "995": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Multi flyer spread",
    "group": "all"
  },
  "996": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Total run outs spread",
    "group": "all"
  },
  "997": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Launch spread",
    "group": "all"
  },
  "998": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "Man of the match player performance spread",
    "group": "all"
  },
  "999": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{%player} total player performance spread",
    "group": "all"
  },
  "1000": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor1} multi run spread",
    "group": "all"
  },
  "1001": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings overs {overnrX} x {overnrY} - {$competitor2} multi run spread",
    "group": "all"
  },
  "1002": {
    "1890": "Vendre",
    "1891": "Acheter",
    "1892": "mid",
    "name": "{!inningnr} innings - {%player} {upsnr} ups spread",
    "group": "all"
  },
  "1006": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "2 ball (1x2)",
    "group": "all"
  },
  "1007": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "2 ball (handicap)",
    "group": "all"
  },
  "1008": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total strokes",
    "group": "all"
  },
  "1010": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total eagles",
    "group": "all"
  },
  "1011": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total birdies",
    "group": "all"
  },
  "1012": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total pars",
    "group": "all"
  },
  "1013": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total bogeys",
    "group": "all"
  },
  "1014": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total 2+ over par",
    "group": "all"
  },
  "1016": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total eagles",
    "group": "all"
  },
  "1017": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total birdies",
    "group": "all"
  },
  "1018": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total pars",
    "group": "all"
  },
  "1019": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total bogeys",
    "group": "all"
  },
  "1020": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total 2+ over par",
    "group": "all"
  },
  "1021": {
    "70": "impair",
    "72": "pair",
    "name": "{%competitor} odd/even strokes",
    "group": "all"
  },
  "1023": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - 2 ball (1x2)",
    "group": "all"
  },
  "1024": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole {holenr} - 2 ball (handicap)",
    "group": "all"
  },
  "1025": {
    "74": "oui",
    "76": "non",
    "name": "Hole {holenr} - any player under par",
    "group": "all"
  },
  "1026": {
    "74": "oui",
    "76": "non",
    "name": "Hole {holenr} - {%competitor} under par",
    "group": "all"
  },
  "1028": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2)",
    "group": "all"
  },
  "1029": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Holes {from} to {to} - 2 ball (handicap)",
    "group": "all"
  },
  "1030": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most birdies",
    "group": "all"
  },
  "1031": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most pars",
    "group": "all"
  },
  "1032": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - 2 ball (1x2) most bogeys",
    "group": "all"
  },
  "1036": {
    "1711": "{$competitor1} ({hcp})",
    "1712": "Match nul ({hcp})",
    "1713": "{$competitor2} ({hcp})",
    "name": "{!quarternr} quart-temps - handicap {hcp}",
    "group": "all"
  },
  "1037": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Atteindra en premier {goals}buts",
    "group": "all"
  },
  "1040": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de frappes (hit) (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1041": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} nombre de frappes (hits) (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1042": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} nombre de frappes (hits) (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1043": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - nombre de frappes (hits)",
    "group": "all"
  },
  "1044": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} nombre de frappes (hits)",
    "group": "all"
  },
  "1045": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} nombre de frappes (hits)",
    "group": "all"
  },
  "1046": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - nombre de bonnes balles",
    "group": "all"
  },
  "1047": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - {$competitor1} nombre de bonnes balles",
    "group": "all"
  },
  "1048": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Manches 1 à 5 - {$competitor2} nombre de bonnes balles",
    "group": "all"
  },
  "1049": {
    "1978": "strike",
    "1979": "balle",
    "1980": "bonne balle (hit)",
    "1981": "autre",
    "name": "Résultat du {!pitchnr} lancer",
    "group": "all|rapid_market|pitch"
  },
  "1050": {
    "74": "oui",
    "76": "non",
    "name": "Bonne balle au {!pitchnr} lancer",
    "group": "all|rapid_market|pitch"
  },
  "1051": {
    "74": "oui",
    "76": "non",
    "name": "Coup de circuit au {!pitchnr} lancer",
    "group": "all|rapid_market|pitch"
  },
  "1052": {
    "1982": "simple jeu (single)",
    "1983": "double jeu",
    "1984": "triple jeu",
    "1985": "coup de circuit (homerun)",
    "1986": "Pas de bonne",
    "name": "Résultat de la {!hitnr} bonne balle",
    "group": "all|rapid_market|hit"
  },
  "1053": {
    "1987": "sur une base",
    "1988": "éliminé",
    "1989": "coup de circuit (homerun)",
    "name": "Résultat de {%player} {!appearancenr} passage à la batte",
    "group": "all|player|rapid_market"
  },
  "1054": {
    "74": "oui",
    "76": "non",
    "name": "{%player} retrait sur troisième strike au {!appearancenr} passage à la batte",
    "group": "all|player|rapid_market"
  },
  "1055": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Vainqueur  et total",
    "group": "all|regular_play|combo"
  },
  "1056": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "{!setnr} set - vainqueur  et total",
    "group": "all|combo|set"
  },
  "1057": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!quarternr} quart-temps - atteindra en premier {pointnr} points",
    "group": "all|score|quarter"
  },
  "1061": {
    "1990": "course (rush)",
    "1991": "passe",
    "name": "{!drivenr} trajet phase de jeu {playnr} - {%competitor} tactique de jeu",
    "group": "all|drive"
  },
  "1062": {
    "74": "oui",
    "76": "non",
    "name": "{!drivenr} trajet phase de jeu {playnr} - {%competitor} passe réussite",
    "group": "all|drive"
  },
  "1063": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!drivenr} trajet phase de jeu {playnr} - {%competitor} nombre de yards gagnés",
    "group": "all|drive"
  },
  "1064": {
    "74": "oui",
    "76": "non",
    "name": "{!drivenr} trajet phase de jeu {playnr} - {%competitor} nouvelle série",
    "group": "all|drive"
  },
  "1065": {
    "74": "oui",
    "76": "non",
    "name": "{!drivenr} trajet phase de jeu {playnr} - {%competitor} plaquage du quaterback",
    "group": "all|drive"
  },
  "1066": {
    "1992": "Coup de pied de dégagement (punt)",
    "1993": "essai (touchdown)",
    "1994": "Coup de pied au but (field goal)",
    "1995": "autre",
    "name": "{!drivenr} trajet - {%competitor} résultat",
    "group": "all|drive"
  },
  "1067": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Vainqueur et total (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1068": {
    "74": "oui",
    "76": "non",
    "name": "Yaura til un grand chelem (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1069": {
    "74": "oui",
    "76": "non",
    "name": "Une équie gagne et lautre ne marque pas ( prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1070": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche - le plus de prises (strikes)",
    "group": "all"
  },
  "1071": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche - le plus de balles (balls)",
    "group": "all"
  },
  "1072": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!inningnr} manche - le plus de frappes (hits)",
    "group": "all"
  },
  "1073": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} manche - nombre exact de coup de circuit (homerun)",
    "group": "all"
  },
  "1074": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} manche - {$competitor1} nombre exact de coup de circuit (homerun)",
    "group": "all"
  },
  "1075": {
    "1996": "0",
    "1997": "1",
    "1998": "2+",
    "name": "{!inningnr} manche - {$competitor2} nombre exact de coup de circuit (homerun)",
    "group": "all"
  },
  "1076": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - nombre total de lancers",
    "group": "all"
  },
  "1077": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor1} nombre total de lancers",
    "group": "all"
  },
  "1078": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manche - {$competitor2} nombre total de lancers",
    "group": "all"
  },
  "1079": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} manche - {$competitor1} nombre exact de retrait sur 3 prises (strikeout)",
    "group": "all"
  },
  "1080": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "{!inningnr} manche - {$competitor2} nombre exact de retrait sur 3 prises (strikeout)",
    "group": "all"
  },
  "1081": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor1} aura un double ou triple jeu (double ou triple play)",
    "group": "all"
  },
  "1082": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} manche - {$competitor2} aura un double ou triple jeu (double ou triple play)",
    "group": "all"
  },
  "1083": {
    "2005": "1-3",
    "2006": "4-5",
    "2007": "6+",
    "name": "Intervalle lancer de {%player} {!appearancenr} fois à la batte",
    "group": "all"
  },
  "1084": {
    "1999": "0",
    "2000": "1",
    "2001": "2",
    "2002": "3",
    "name": "Nombre de prises (strikes) pour {%player} {!appearancenr} passage à la batte",
    "group": "all"
  },
  "1085": {
    "1005": "0",
    "1006": "1",
    "1007": "2",
    "1008": "3",
    "1009": "4",
    "name": "Nombre de balles (balls) pour {%player} {!appearancenr} passage à la batte",
    "group": "all"
  },
  "1086": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Vitesse du{!pitchnr} pitch",
    "group": "all"
  },
  "1087": {
    "961": "0",
    "962": "1",
    "963": "2",
    "964": "3",
    "965": "4",
    "966": "5+",
    "name": "Nombre de coup de circuit (homerun) (prolongations incluses)",
    "group": "all|incl_ei"
  },
  "1088": {
    "2008": "{$competitor1} marque à 1 point",
    "2009": "{$competitor1} marque à 2 points",
    "2010": "{$competitor1} marque à 3 points",
    "2011": "{$competitor2} marque à 1 point",
    "2012": "{$competitor2} marque à 2 points",
    "2013": "{$competitor2} marque à 3 points",
    "name": "Manière de marquer {!pointnr} point (prolongation incl.)",
    "group": "all"
  },
  "1089": {
    "2014": "marque à 1 point",
    "2015": "marque à 2 points",
    "2016": "marque à 3 points",
    "name": "Manière de marquer {!pointnr} point dune des équipes (prolongation incl.)",
    "group": "all"
  },
  "1090": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quart-temps - {!pointnr} point",
    "group": "all"
  },
  "1096": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total de tours au {!stopnr} arrêt au stand",
    "group": "all"
  },
  "1097": {
    "2017": "1-2",
    "2018": "3-4",
    "2019": "5-6",
    "2020": "7-8",
    "2021": "9-10",
    "2022": "11+",
    "name": "Position sur la grille du vainqueur (fourchette)",
    "group": "all"
  },
  "1098": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} nombre de dépassements",
    "group": "all"
  },
  "1099": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de finisseurs",
    "group": "all"
  },
  "1100": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de dépassements",
    "group": "all"
  },
  "1106": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%team} total de dépassements",
    "group": "all"
  },
  "1108": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!lapnr} tour - nombre dabandons",
    "group": "all"
  },
  "1119": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Course à {pointnr} points",
    "group": "all"
  },
  "1120": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Nombre de coup de circuits (homeruns) (prolongations incluses)",
    "group": "all|incl_ei|home_run"
  },
  "1121": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} nombre de coup de circuits (homeruns) (prolongations incluses)",
    "group": "all|incl_ei|home_run"
  },
  "1122": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} nombre de coup de circuits (homeruns) (prolongations incluses)",
    "group": "all|incl_ei|home_run"
  },
  "1123": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!inningnr} manche - Vainqueur",
    "group": "all|inning"
  },
  "1124": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Manche 1 à 5 - Vainqueur",
    "group": "all|5_innings"
  },
  "1125": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings - {%player1} to score {milestone} & {%player2} {total} + dismissals",
    "group": "all"
  },
  "1127": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings - {%player1} to score {milestone1} & {%player2} to score {milestone2}",
    "group": "all"
  },
  "1128": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings - {%player1} & {%player2} to score {milestone} & {%player3} {total} + dismissals",
    "group": "all"
  },
  "1129": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {%player1} + {%player2} total",
    "group": "all"
  },
  "1130": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} manches - {%player1} + {%player2} + {%player3} total",
    "group": "all"
  },
  "1131": {
    "74": "oui",
    "76": "non",
    "name": "Les deux équipes vont-elles marquer {milestone}",
    "group": "all"
  },
  "1132": {
    "74": "oui",
    "76": "non",
    "name": "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor1} {total} +",
    "group": "all"
  },
  "1133": {
    "74": "oui",
    "76": "non",
    "name": "{!inningsnr} innings  over {overnr} - deliveries {deliverynr1} & {deliverynr2} {$competitor2} {total} +",
    "group": "all"
  },
  "1134": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} manches - {%player1} & {%player2} méthode délimination",
    "group": "all"
  },
  "1135": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Which team has the highest 1st partnership & 1st over & overs 0 to {overnr}",
    "group": "all"
  },
  "1136": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "autre",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} exact runs",
    "group": "all"
  },
  "1137": {
    "2026": "0",
    "2027": "1",
    "2028": "2",
    "2029": "3",
    "2030": "4",
    "2031": "6",
    "2032": "autre",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} exact runs",
    "group": "all"
  },
  "1138": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor1} to be a wicket",
    "group": "all"
  },
  "1139": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {!deliverynr} delivery {$competitor2} to be a wicket",
    "group": "all"
  },
  "1140": {
    "1806": "arrêt de volée par chasseur",
    "1807": "guichet détruit par le lanceur",
    "1808": "arrêt de volée par gardien",
    "1809": "jambe devant guichet",
    "1810": "run out",
    "1811": "guichet détruit par le gardien",
    "1812": "autre",
    "name": "{!inningnr} innings - {%player1} or {%player2} dismissal method",
    "group": "all"
  },
  "1141": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} to hit a boundary",
    "group": "all"
  },
  "1142": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {%player1} & {%player2} {total} +",
    "group": "all"
  },
  "1143": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {$competitor1} to score a boundary four & a six",
    "group": "all"
  },
  "1144": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings over {overnr} - {$competitor2} to score a boundary four & a six",
    "group": "all"
  },
  "1145": {
    "74": "oui",
    "76": "non",
    "name": "{!inningnr} innings - {%player1} or {%player2} to survive a review",
    "group": "all"
  },
  "1146": {
    "2023": "{%player1}",
    "2024": "aucun",
    "2025": "{%player2}",
    "name": "{!inningnr} manches - course à {runs} points",
    "group": "all"
  },
  "1147": {
    "74": "oui",
    "76": "non",
    "name": "{%player} to score {milestone} & take a wicket & a catch",
    "group": "all"
  },
  "1148": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Supérieur à {!overnr} - {$competitor1} ({ballcount} balles)",
    "group": "all"
  },
  "1149": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!overnr} over - {$competitor2} total ({ballcount}-ball overs)",
    "group": "all"
  },
  "1150": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Overs 0 to {overnr} - {$competitor1} total ({ballcount}-ball overs)",
    "group": "all"
  },
  "1151": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Overs 0 to {overnr} - {$competitor2} total ({ballcount}-ball overs)",
    "group": "all"
  },
  "1152": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total rushing touchdowns (incl. overtime)",
    "group": "all"
  },
  "1158": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "2 ball",
    "group": "all"
  },
  "1160": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Remboursé si match nul",
    "group": "all"
  },
  "1161": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Head2head (1x2)",
    "group": "all"
  },
  "1162": {
    "1969": "{%competitor1} ({+hcp})",
    "1970": "{%competitor2} ({-hcp})",
    "name": "Hole handicap",
    "group": "all"
  },
  "1163": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%competitor} total holes won",
    "group": "all"
  },
  "1165": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total holes played",
    "group": "all"
  },
  "1166": {
    "74": "oui",
    "76": "non",
    "name": "Will there be a tie",
    "group": "all"
  },
  "1168": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Hole {holenr} - head2head (1x2)",
    "group": "all"
  },
  "1169": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Trou {holenr} - Remboursé si égalité",
    "group": "all"
  },
  "1170": {
    "1966": "{%competitor1}",
    "1967": "Egalité",
    "1968": "{%competitor2}",
    "name": "Holes {from} to {to} - head2head (1x2)",
    "group": "all"
  },
  "1171": {
    "2033": "{%competitor1}",
    "2034": "{%competitor2}",
    "name": "Trous de {from} à {to} - Remboursé si égalité",
    "group": "all"
  },
  "1173": {
    "973": "{$competitor1} & {total} +",
    "974": "{$competitor2} & {total} +",
    "975": "{$competitor1} & {total} -",
    "976": "{$competitor2} & {total} -",
    "name": "Winner (including OT) & Total (including OT)",
    "group": "all"
  },
  "1174": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "Handicap (including OT) & Total (including OT)",
    "group": "all|combo|incl_ot"
  },
  "1175": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1st quarter 1x2 & 1st quarter total",
    "group": "all|combo|incl_ot"
  },
  "1176": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st quarter handicap & 1st quarter total",
    "group": "all|combo|incl_ot"
  },
  "1177": {
    "794": "{$competitor1} & {total} -",
    "796": "{$competitor1} & {total} +",
    "798": "Match nul & {total} -",
    "800": "Match nul & {total} +",
    "802": "{$competitor2} & {total} -",
    "804": "{$competitor2} & {total} +",
    "name": "1st half 1x2 & 1st half total",
    "group": "all|combo|incl_ot"
  },
  "1178": {
    "2035": "{$competitor1} ({+hcp}) & {total} +",
    "2036": "{$competitor1} ({+hcp}) & {total} -",
    "2037": "{$competitor2} ({-hcp}) & {total} +",
    "2038": "{$competitor2} ({-hcp}) & {total} -",
    "name": "1st half handicap & 1st half total",
    "group": "all|combo|incl_ot"
  },
  "1179": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "1st Half Result or Match Result",
    "group": "all|regular_play"
  },
  "1183": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total shots (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1185": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total shots on goal (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1187": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total passes (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1189": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total tackles (incl. overtime)",
    "group": "all|incl_ot"
  },
  "1193": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Highest scoring quarter - total",
    "group": "all|score|regular_play"
  },
  "1195": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Lowest scoring quarter - total",
    "group": "all|score|regular_play"
  },
  "1197": {
    "74": "oui",
    "76": "non",
    "name": "Any team to win both halves",
    "group": "all|score|regular_play"
  },
  "1199": {
    "74": "oui",
    "76": "non",
    "name": "Any team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1201": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Team to win both halves",
    "group": "all|score|regular_play"
  },
  "1203": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Team to win all quarters",
    "group": "all|score|regular_play"
  },
  "1207": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Next {!breaknr} break",
    "group": "all"
  },
  "1209": {
    "2039": "{$competitor1} 6-0, 6-1, 6-2",
    "2040": "{$competitor1} 6-3, 6-4",
    "2041": "{$competitor1} 7-5, 7-6",
    "2042": "{$competitor2} 6-0, 6-1, 6-2",
    "2043": "{$competitor2} 6-3, 6-4",
    "2044": "{$competitor2} 7-5, 7-6",
    "name": "{!setnr} set - exact score group",
    "group": "all"
  },
  "1211": {
    "74": "oui",
    "76": "non",
    "name": "Match to end {score}",
    "group": "all"
  },
  "1214": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} total deliveries faced",
    "group": "all"
  },
  "1215": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings - {%player} runs conceded",
    "group": "all"
  },
  "1218": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor1} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1219": {
    "2045": "4",
    "2046": "6",
    "name": "{!inningnr} innings - {$competitor2} next boundary {boundary number} off Bat, Four or Six",
    "group": "all"
  },
  "1220": {
    "54": "0",
    "56": "1",
    "58": "2",
    "60": "3+",
    "name": "Total batsman milestones (50s/100s)",
    "group": "all"
  },
  "1221": {
    "1037": "arrêt de volée",
    "1038": "pas d arrêt de volée",
    "name": "{!inningnr} innings - {$competitor1}  {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1222": {
    "1037": "arrêt de volée",
    "1038": "pas d arrêt de volée",
    "name": "{!inningnr} innings - {$competitor2}  {!dismissalnr} dismissal method (limited)",
    "group": "all"
  },
  "1229": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor1} total",
    "group": "all"
  },
  "1230": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!inningnr} innings overs 0 to {overnr} - {$competitor2} total",
    "group": "all"
  },
  "1231": {
    "74": "oui",
    "76": "non",
    "name": "Sum of bonus balls exact number",
    "group": "all"
  },
  "1242": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "Race to home {homepoints} and away {awaypoints} points",
    "group": "all"
  },
  "1243": {
    "74": "oui",
    "76": "non",
    "name": "Anytime exact score {homepoints}:{awaypoints}",
    "group": "all"
  },
  "1244": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "King of the Oche (Match Treble)",
    "group": "all"
  },
  "1246": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Player with highest checkout",
    "group": "all"
  },
  "1248": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Highest checkout in match",
    "group": "all"
  },
  "1250": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total {points}+ checkouts",
    "group": "all"
  },
  "1252": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Match winner & highest checkout",
    "group": "all"
  },
  "1254": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Match winner & most 180s",
    "group": "all"
  },
  "1256": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "Highest checkout & most 180s",
    "group": "all"
  },
  "1258": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "To lead after {!legnr} leg",
    "group": "all"
  },
  "1260": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!legnr} leg checkout total",
    "group": "all"
  },
  "1264": {
    "74": "oui",
    "76": "non",
    "name": "170 checkout in match",
    "group": "all"
  },
  "1269": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set game {gamenr} - ace",
    "group": "all|micro_market"
  },
  "1270": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!acenr} ace",
    "group": "all|micro_market"
  },
  "1271": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total points",
    "group": "all|player_props"
  },
  "1272": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total points",
    "group": "all|player_props"
  },
  "1273": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total breaks",
    "group": "all|player_props"
  },
  "1274": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total aces",
    "group": "all|player_props"
  },
  "1275": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor2} total aces",
    "group": "all|player_props"
  },
  "1276": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "{!setnr} set - most aces",
    "group": "all|player_props"
  },
  "1277": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set - {$competitor1} total breaks",
    "group": "all|player_props"
  },
  "1278": {
    "74": "oui",
    "76": "non",
    "name": "Both players to win a set",
    "group": "all|score|regular_play"
  },
  "1279": {
    "2047": "4:0",
    "2048": "3:1",
    "2049": "2:2",
    "2050": "1:3",
    "2051": "0:4",
    "name": "{!setnr} set - correct score after 4 games",
    "group": "all|score|set"
  },
  "1280": {
    "2052": "6:0",
    "2053": "5:1",
    "2054": "4:2",
    "2055": "3:3",
    "2056": "2:4",
    "2057": "1:5",
    "2058": "0:6",
    "name": "{!setnr} set - correct score after 6 games",
    "group": "all|score|set"
  },
  "1281": {
    "6": "{$competitor1}",
    "7": "aucun",
    "8": "{$competitor2}",
    "name": "{!setnr} set - {!breaknr} break",
    "group": "all|score|set|micro_market"
  },
  "1282": {
    "74": "oui",
    "76": "non",
    "name": "{!setnr} set game {gamenr} - break point",
    "group": "all|score|game|micro_market"
  },
  "1283": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Booking handicap",
    "group": "all|regular_play|bookings"
  },
  "1284": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Overtime 1st half - total",
    "group": "all|score|ot_1st_half"
  },
  "1285": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total points",
    "group": "all|score|regular_play|player_props"
  },
  "1286": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total points",
    "group": "all|score|regular_play|player_props"
  },
  "1287": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1288": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total breaks",
    "group": "all|score|regular_play|player_props"
  },
  "1289": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1290": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1291": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Most aces",
    "group": "all|regular_play|player_props|ace"
  },
  "1292": {
    "2059": "point after rally",
    "2060": "ace",
    "2061": "double fault",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point serve outcome",
    "group": "all|score|points|micro_market"
  },
  "1293": {
    "2064": "{$competitor1} winner",
    "2065": "{$competitor2} winner",
    "2066": "{$competitor1} error",
    "2067": "{$competitor2} error",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point outcome",
    "group": "all|score|points|micro_market"
  },
  "1294": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point total shots",
    "group": "all|score|points|micro_market"
  },
  "1295": {
    "2068": "serve",
    "2069": "return",
    "2070": "forehand",
    "2071": "backhand",
    "2072": "volley",
    "name": "{!setnr} set game {gamenr} - {!pointnr} point last stroke",
    "group": "all|score|points|micro_market"
  },
  "1296": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total yellow cards",
    "group": "all|regular_play|bookings"
  },
  "1297": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Total red cards",
    "group": "all|regular_play|bookings"
  },
  "1298": {
    "1": "{$competitor1}",
    "2": "Match nul",
    "3": "{$competitor2}",
    "name": "Yellow card 1x2",
    "group": "all|regular_play|bookings"
  },
  "1299": {
    "1714": "{$competitor1} ({+hcp})",
    "1715": "{$competitor2} ({-hcp})",
    "name": "Yellow card handicap",
    "group": "all|regular_play|bookings"
  },
  "1300": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total points (incl. overtime)",
    "group": "all"
  },
  "1301": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total assists (incl. overtime)",
    "group": "all"
  },
  "1302": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total rebounds (incl. overtime)",
    "group": "all"
  },
  "1303": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total 3-point field goals (incl. overtime)",
    "group": "all"
  },
  "1304": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{%player} total points + rebounds + assists (incl. overtime)",
    "group": "all|combo|incl_ot|player_props"
  },
  "1305": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "1st half - {points} point score draw no bet",
    "group": "all|score|1st_half|micro_market"
  },
  "1306": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2nd half - {points} point score draw no bet",
    "group": "all|score|2nd_half|micro_market"
  },
  "1307": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "{!quarternr} quarter - {points} point score draw no bet",
    "group": "all|score|quarter|micro_market"
  },
  "1308": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1309": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - {points} point score draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1310": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "2 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|2_min"
  },
  "1311": {
    "4": "{$competitor1}",
    "5": "{$competitor2}",
    "name": "4 minutes - draw no bet from {from} to {to} remaining",
    "group": "all|score|micro_market|4_min"
  },
  "1312": {
    "2073": "score",
    "2074": "no score",
    "name": "{!possessionnr} possession outcome",
    "group": "all|score|regular_play|micro_market"
  },
  "1313": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor1} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1314": {
    "74": "oui",
    "76": "non",
    "name": "{$competitor2} to win all quarters",
    "group": "all|score|regular_play"
  },
  "1315": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor1} total double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1316": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "{$competitor2} total double faults",
    "group": "all|regular_play|player_props|double fault"
  },
  "1500": {
    "12": "{total} +",
    "13": "{total} -",
    "name": "Rest of Total match",
    "group": "all"
  },
  "1601": {
    "16001": "{$competitor1} & 2-3 goals",
    "16002": "{$competitor1} & 2-4 goals",
    "16003": "{$competitor1} & 2-5 goals",
    "16004": "{$competitor1} & 3-4 goals",
    "16005": "{$competitor1} & 3-5 goals",
    "16006": "{$competitor1} & 3-6 goals",
    "16007": "draw & 2-3 goals",
    "16008": "draw & 2-4 goals",
    "16009": "draw & 2-5 goals",
    "16010": "draw & 3-4 goals",
    "16011": "draw & 3-5 goals",
    "16012": "draw & 3-6 goals",
    "16013": "{$competitor2} & 2-3 goals",
    "16014": "{$competitor2} & 2-4 goals",
    "16015": "{$competitor2} & 2-5 goals",
    "16016": "{$competitor2} & 3-4 goals",
    "16017": "{$competitor2} & 3-5 goals",
    "16018": "{$competitor2} & 3-6 goals",
    "name": "1x2 & Multigoals",
    "group": "all"
  },
  "1602": {
    "16021": "{$competitor1} or draw & 2-3 goals",
    "16022": "{$competitor1} or draw & 2-4 goals",
    "16023": "{$competitor1} or draw & 2-5 goals",
    "16024": "{$competitor1} or draw & 3-4 goals",
    "16025": "{$competitor1} or draw & 3-5 goals",
    "16026": "{$competitor1} or draw & 3-6 goals",
    "16027": "{$competitor1} or {$competitor2} & 2-3 goals",
    "16028": "{$competitor1} or {$competitor2} & 2-4 goals",
    "16029": "{$competitor1} or {$competitor2} & 2-5 goals",
    "16030": "{$competitor1} or {$competitor2} & 3-4 goals",
    "16031": "{$competitor1} or {$competitor2} & 3-5 goals",
    "16032": "{$competitor1} or {$competitor2} & 3-6 goals",
    "16033": "draw or {$competitor2} & 2-3 goals",
    "16034": "draw or {$competitor2} & 2-4 goals",
    "16035": "draw or {$competitor2} & 2-5 goals",
    "16036": "draw or {$competitor2} & 3-4 goals",
    "16037": "draw or {$competitor2} & 3-5 goals",
    "16038": "draw or {$competitor2} & 3-6 goals",
    "name": "Double chance & Multigoals",
    "group": "all"
  },
  "1603": {
    "16040": "0:0/1:1",
    "16041": "0:1/0:2/1:2",
    "16042": "0:3/1:3/2:3",
    "16043": "1:0/2:0/2:1",
    "16044": "1:4/2:4/3:4",
    "16045": "2:2/3:3/4:4",
    "16046": "3:0/3:1/3:2",
    "16047": "4:1/4:2/4:3",
    "16048": "4:0/0:4/Other",
    "name": "Multiscore-3",
    "group": "all"
  },
  "1604": {
    "16050": "0:0/1:1/0:1/1:0",
    "16051": "0:2/1:2/0:3/1:3",
    "16052": "0:4/1:4/2:4/3:4",
    "16053": "2:0/2:1/3:0/3:1",
    "16054": "2:2/2:3/3:2/3:3",
    "16055": "4:0/4:1/4:2/4:3",
    "16056": "4:4/Other",
    "name": "Multiscore-4",
    "group": "all"
  },
  "1605": {
    "16057": "{$competitor1} or no",
    "16058": "{$competitor1} or yes",
    "16059": "{$competitor2} or no",
    "16060": "{$competitor2} or yes",
    "16061": "draw or no",
    "16062": "draw or yes",
    "name": "1x2 or both teams to score",
    "group": "all"
  },
  "1606": {
    "16063": "{$competitor1}/draw / {$competitor1}/draw",
    "16064": "{$competitor1}/draw / {$competitor1}/{$competitor2}",
    "16065": "{$competitor1}/draw / draw/{$competitor2}",
    "16066": "{$competitor1}/{$competitor2} / {$competitor1}/draw",
    "16067": "{$competitor1}/{$competitor2} / draw/{$competitor2}",
    "16068": "draw/{$competitor2} / {$competitor1}/draw",
    "16069": "{$competitor1}/{$competitor2} / {$competitor1}/{$competitor2}",
    "16070": "draw/{$competitor2} / {$competitor1}/{$competitor2}",
    "16071": "draw/{$competitor2} / draw/{$competitor2}",
    "name": "Double chance Halftime/Fulltime",
    "group": "all"
  },
  "1607": {
    "16072": "{$competitor1} or {total} over",
    "16073": "draw or {total} over",
    "16074": "{$competitor2} or {total} over",
    "16075": "{$competitor1} or {total} under",
    "16076": "draw or {total} under",
    "16077": "{$competitor2} or {total} under",
    "name": "1x2 or {total} total",
    "group": "all"
  },
  "1608": {
    "16078": "yes or {total} over",
    "16079": "yes or {total} under",
    "16080": "no or {total} over",
    "16081": "no or {total} under",
    "name": "Both team to score or {total} total",
    "group": "all"
  },
  "1609": {
    "16082": "{$competitor1} and yes and {total} over",
    "16083": "{$competitor1} and no and {total} over",
    "16084": "{$competitor1} and no and {total} under",
    "16085": "draw and yes and {total} over",
    "16086": "draw and yes and {total} under",
    "16087": "draw and no and {total} under",
    "16088": "{$competitor2} and yes and {total} over",
    "16089": "{$competitor2} and no and {total} over",
    "16090": "{$competitor2} and no and {total} under",
    "name": "1x2 and Both team to score and {total} total",
    "group": "all"
  },
  "1610": {
    "16091": "<1 and <1",
    "16092": ">=1 and >=1",
    "16093": "<1 and <2",
    "16094": ">=1 and >=2",
    "16095": "<1 and <3",
    "16096": ">=1 and >=3",
    "16097": "<2 and <1",
    "16098": ">=2 and >=1",
    "16099": "<2 and <2",
    "16100": ">=2 and >=2",
    "16101": "<2 and <3",
    "16102": ">=2 and >=3",
    "16103": "<3 and <1",
    "16104": ">=3 and >=1",
    "16105": ">=3 and >=2",
    "16106": ">=3 and >=3",
    "name": "Exact goals in HT/2HT",
    "group": "all"
  },
  "1612": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 5 minutes",
    "group": "all"
  },
  "1613": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 10 minutes",
    "group": "all"
  },
  "1614": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 15 minutes",
    "group": "all"
  },
  "1615": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 20 minutes",
    "group": "all"
  },
  "1616": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 30 minutes",
    "group": "all"
  },
  "1617": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "1x2 in 60 minutes",
    "group": "all"
  },
  "1618": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 5 min",
    "group": "all"
  },
  "1619": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 10 min",
    "group": "all"
  },
  "1620": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 15 min",
    "group": "all"
  },
  "1621": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 20 min",
    "group": "all"
  },
  "1622": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 30 min",
    "group": "all"
  },
  "1623": {
    "74": "yes",
    "76": "no",
    "name": "Score in first 60 min",
    "group": "all"
  },
  "1624": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 2 goals in a row",
    "group": "all"
  },
  "1625": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1626": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 2 goals in a row",
    "group": "all"
  },
  "1627": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor2} 3 goals in a row",
    "group": "all"
  },
  "1628": {
    "74": "yes",
    "76": "no",
    "name": "Any 2 goals in a row",
    "group": "all"
  },
  "1629": {
    "74": "yes",
    "76": "no",
    "name": "{$competitor1} 3 goals in a row",
    "group": "all"
  },
  "1630": {
    "74": "yes",
    "76": "no",
    "name": "Both team to score 2+",
    "group": "all"
  },
  "1631": {
    "1": "{$competitor1}",
    "2": "draw",
    "3": "{$competitor2}",
    "name": "Halftime or fulltime",
    "group": "all"
  },
  "1632": {
    "1724": "{$competitor1}/draw &{total} -",
    "1725": "{$competitor1}/{$competitor2} & {total} -",
    "1726": "draw/{$competitor2} & {total} -",
    "1727": "{$competitor1}/draw & {total} +",
    "1728": "{$competitor1}/{$competitor2} & {total} +",
    "1729": "draw/{$competitor2} & {total} +",
    "name": "1st half - Double chance and Total Halftime or Fulltime",
    "group": "all"
  },
  "1633": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "Double chance (1st half) & 1x2",
    "group": "all"
  },
  "1634": {
    "16114": "{$competitor1}/draw & {$competitor1}",
    "16115": "{$competitor1}/draw & {$competitor2}",
    "16116": "{$competitor1}/draw & draw",
    "16117": "{$competitor1}/{$competitor2} & {$competitor1}",
    "16118": "{$competitor1}/{$competitor2} & {$competitor2}",
    "16119": "{$competitor1}/{$competitor2} & draw",
    "16120": "draw/{$competitor2} & {$competitor1}",
    "16121": "draw/{$competitor2} & {$competitor2}",
    "16122": "draw/{$competitor2} & draw",
    "name": "1x2 (1st half) & Double chance",
    "group": "all"
  }
};

export const global_marketname = {
  "1": "1x2",
  "7": "Match restant",
  "8": "Prochain but",
  "10": "Double chance",
  "18": "Plus/Moins",
  "19": "Total de l'équipe à domicile",
  "20": "Total de l'équipe à l'extérieur",
  "186": "Vainqueur",
  "219": "12 y compris prolongation",
  "225": "Plus/Moins y compris prolongation",
  "251": "Vainqueur",
  "258": "Plus/Moins y compris prolongation",
  "340": "Vainqueur"
};
